// Global Variables
window.reactPlayers = {};
window.renderWebSocket = null;

function isValidDomain(origin, customDomain = "") {
  // Domain and api domain
  const params = window.location.search
    ? new URLSearchParams(window.location.search)
    : false;
  const env = params ? params.get("env") || "" : "localhost";

  let allowedOrigins = [
    "https://www.gevme.com",
    "https://showcase-dev.gevme.com",
    "https://showcase-dev.gev.me",
    "https://showcase.gev.me",
    "https://live.gev.me",
    "https://live.gevme.com",
    "https://live-dev.gevme.com",
    "https://admin.gevme.com",
    "https://admin.gev.me",
    "https://admin-dev.gevme.com",
  ];

  if (env === "localhost") {
    allowedOrigins.push("http://localhost:3001");
    allowedOrigins.push("http://localhost:3002");
  }

  if (customDomain) {
    allowedOrigins.push(customDomain);
  }

  if (window.GEVME?.setting?.customDomain) {
    allowedOrigins.push(window.GEVME?.setting?.customDomain);
  }

  return allowedOrigins.some((domain) => origin === domain);
}

const WEBSOCKET_TRIES_EQUIVALENT = {
  1: 1,
  2: 3,
  3: 5,
  4: 10,
  5: 20,
};
let WEBSOCKET_RETRY_COUNT = 0;
let WEBSOCKET_RETRY_ARRAY = [];
let WEBSOCKET_TIME_OF_OPEN = new Date();

const ADOBE_DATA_LAYER = {
  clickSpeaker: (name) => ({
    event: "speakers:speaker:card:click",
    eventInteraction: {
      speakers: {
        speaker: {
          name, // Speaker’s name
          card: {
            action: "click",
          },
        },
      },
    },
  }),
  trackVideo: ({ id, name, url, duration = 0 }) => ({
    event: "videos:video:playback:start",
    eventInteraction: {
      videos: {
        video: {
          id,
          duration,
          name,
          url,
          playback: {
            action: "start",
          },
        },
      },
    },
  }),
};

const trackAdobeAnalytics = (activity = {}) => {
  try {
    let adobeDataLayer = window.adobeDataLayer || [];
    const isAdobeDataLayerEnabled =
      !!window.GEVME.analytics.adobeAnalyticsScriptUrl;

    const playedVideos =
      JSON.parse(window.localStorage.getItem("playedVideos")) || {};
    const videoId = activity?.eventInteraction?.videos?.video?.id;

    if (activity?.event === "videos:video:playback:start") {
      if (!playedVideos[videoId]) {
        window.localStorage.setItem(
          "playedVideos",
          JSON.stringify({
            ...playedVideos,
            [videoId]: {
              played: true,
            },
          })
        );
      }
      if (playedVideos[videoId]) return;
    }

    if (adobeDataLayer && isAdobeDataLayerEnabled) {
      const payload = {
        ...activity,
        userDetails: {
          id: window.GEVME?.user?.id || null,
        },
      };
      console.log({ payload });
      adobeDataLayer.push(payload);
    }
  } catch (error) {
    console.error("Error sending activity to render frame:", error);
  }
};
const handlePlayEvent = (videoId, videoTitle, videoUrl, ivsPlayer = null) => {
  try {
    const playedVideos =
      JSON.parse(window.localStorage.getItem("playedVideos")) || {};

    if (playedVideos[videoId]) return;

    const player = ivsPlayer || {};
    let duration = ivsPlayer ? player.duration() : 0;
    if (ivsPlayer) {
      console.log("isIVSplayer: ", { duration, player });
      const activity = ADOBE_DATA_LAYER.trackVideo({
        id: videoId,
        name: videoTitle,
        url: videoUrl,
        duration,
      });
      trackAdobeAnalytics(activity);
    }
    if (!ivsPlayer) {
      const nonIVSPlayer = window.reactPlayers[videoId].getInternalPlayer();
      console.log("nonIVSPlayer: ", { nonIVSPlayer });
      if (nonIVSPlayer && nonIVSPlayer.getDuration) {
        console.log("nonIVSPlayer: ", { nonIVSPlayer });
        const durationFunc = nonIVSPlayer.getDuration();
        if (typeof durationFunc.then === "function") {
          console.log(
            "typeof durationFunc.then === 'function': ",
            durationFunc
          );
          durationFunc
            .then((res) => {
              duration = res;
              const activity = ADOBE_DATA_LAYER.trackVideo({
                id: videoId,
                name: videoTitle,
                url: videoUrl,
                duration,
              });
              console.log({ activity });
              trackAdobeAnalytics(activity);
            })
            .catch((err) => console.error(err));
        } else {
          console.log("else: ", durationFunc);
          duration = durationFunc;
          const activity = ADOBE_DATA_LAYER.trackVideo({
            id: videoId,
            name: videoTitle,
            url: videoUrl,
            duration,
          });
          trackAdobeAnalytics(activity);
        }
      }
    }
  } catch (error) {
    console.error(error);
  }
};

const debounceUtility = (func, timeout = 200) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};

const displayReaction = ({ block, reactionId }) => {
  try {
    const videoParentEl = document.querySelector(`div[data-id="${block.id}"`);
    const selectedEmoji = window.GEVME.reactions.filter(
      (reaction) => reaction.id === reactionId
    )[0];
    const img = document.createElement("img");
    img.src = selectedEmoji.icon;
    img.alt = selectedEmoji.name;
    const styleRandomId = `${reactionId}-${
      block.id
    }-${Date.now()}-${`${Math.random()}`.replace(".", "")}`;
    const styleClassName = `gevmeReaction-${styleRandomId}`;
    const styleKeyFrameName = `gevmeReactionEmojiAnimation-${styleRandomId}`;
    img.className = styleClassName;
    // random number between 0.1 to 0.25
    let random = Math.random() * (0.25 - 0.1) + 0.1;
    img.style.left = `${
      videoParentEl.offsetWidth - videoParentEl.offsetWidth * random
    }px;`;
    img.style.left = `${Math.floor(Math.random() * 90)}%`;
    let leftStartStyle = "";
    let leftEndPixels = "";
    switch (block.reactionPosition) {
      case "bottom_right":
      default: {
        leftStartStyle = "left: calc(100% - 45px);";
        leftEndPixels =
          videoParentEl.offsetWidth - videoParentEl.offsetWidth * random;
        break;
      }
      case "bottom_left": {
        leftStartStyle = "left: 45px;";
        leftEndPixels = videoParentEl.offsetWidth * random;
        break;
      }
      case "bottom_center": {
        leftStartStyle = "left: calc(50% - 17px);";
        random = Math.random() > 0.5 ? random : -random;
        leftEndPixels =
          videoParentEl.offsetWidth / 2 -
          17 +
          videoParentEl.offsetWidth * random;
        break;
      }
    }
    const style = document.createElement("style");
    style.type = "text/css";
    document.getElementsByTagName("head")[0].appendChild(style);
    style.innerHTML = `
            .${styleClassName} {
                position: absolute;
                width: 100%;
                height: 100%;
                max-width: 42px;
                max-height: 42px;
                border: 1px solid #000;
                border-radius: 50%;
                padding: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: rgba(0, 0, 0, 0.5);
                z-index: 888;
                animation: ${styleKeyFrameName} ease-in-out 3000ms 1 forwards, shakeAnim 900ms cubic-bezier(0.64, 0.57, 0.67, 1.53) infinite alternate;
                cursor: none !important;
             }
            @keyframes ${styleKeyFrameName} {
                0% {
                    bottom: 34px;
                    opacity: 0;
                    filter: scale(0);
                    ${leftStartStyle}
                }
                60% {
                    opacity: 1;
                    filter: scale(2);
                }
                100% {
                    bottom: 90%;
                    opacity: 0;
                    filter: scale(2.5);
                    left: ${leftEndPixels}px;
                }
            }
            @keyframes shakeAnim {
                0%  {
                    transform: translate(2px, 1px) rotate(30deg) scale(1.25);
                }
                50%  {
                    transform: translate(-2px, -1px) rotate(-30deg) scale(1.25);
                }
                100%  {
                    transform: translate(0px, 0px) rotate(0deg) scale(1);
                }
            }
        `;
    videoParentEl.appendChild(img);
    // for clean up after 5 seconds inorder to remove this temporary elements
    setTimeout(() => {
      img.remove();
      style.remove();
    }, 5000);
  } catch (error) {
    console.error(error);
  }
};

const attachReactionEvent = () => {
  try {
    var emojis = document.querySelectorAll(".gevme-emoji-selectable-item");
    var blocks = Object.values(window.GEVME.livepage.showcaseblocks);

    if (emojis && emojis.length) {
      for (var emoji of emojis) {
        if (emoji) {
          emoji.onclick = debounceUtility(function (e) {
            e.preventDefault();
            var _this = e.target;
            var targetBlockId = _this.dataset.targetBlock;
            var block = blocks.filter((block) => block.id === targetBlockId)[0];
            var playerId = _this.dataset.playerId;
            var emojiId = _this.dataset.emojiId;
            var emojiName = _this.alt;
            var isPrivatePage = window.GEVME.livepage.type === "live_page";
            var videoElement = document.querySelector(
              `div[data-id="${targetBlockId}"`
            );
            var isUsingIVS = videoElement.dataset.ivs === "true";
            var player, timeStamp, payload;

            if (isUsingIVS) {
              // If player is using IVS
              player = window.videojs.players[playerId];
              if (player) {
                timeStamp = player.currentTime();
              } else throw new Error("Needed data is insufficient");
            } else if (window.reactPlayers[targetBlockId]) {
              // If using react player
              player = window.reactPlayers[targetBlockId];
              if (!player) throw new Error("No player found");
              timeStamp = Math.floor(player.getCurrentTime() || 0);
            }

            payload = {
              action: "reaction",
              data: { timeStamp, targetBlockId, emojiId },
            };

            if (window._paq && timeStamp > 0) {
              window._paq.push([
                "trackEvent",
                `${emojiName} | Reaction`,
                timeStamp,
                `${block.headingPlain} | ${
                  block.livestreamUrl || block.videoUrl
                }`,
              ]);
            }

            if (isPrivatePage) {
              // Send to parent app [template | website]
              window.parent.postMessage(JSON.stringify(payload), "*");
            }
            displayReaction({ block, reactionId: emojiId });
          });
        }
      }
    } else throw new Error("No emojis found");
  } catch (error) {
    console.error(error);
  }
};

const fetchExhibitor = async (projectId = "", boothNumber = "") => {
  try {
    projectId = projectId || window.GEVME.project.id;
    const API_DOMAIN =
      window.GEVME.setting.customDomain || window.GEVME.setting.apiDomain;
    let API_URL = `${API_DOMAIN}/v1/livestream/sponsors/list?projectId=${projectId}&limit=0`;
    if (boothNumber) {
      API_URL = `${API_DOMAIN}/v1/livestream/sponsors/${boothNumber}?projectId=${projectId}`;
    }
    const options = {
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await fetch(API_URL, options);
    const data = await res.json();
    if (!data?.status) throw res;
    return boothNumber ? data?.sponsor || null : data?.sponsors || [];
  } catch (error) {
    console.error(error?.message || "Something went wrong");
    return boothNumber ? null : [];
  }
};

const retrieveAndRenderAllVideoBlockPlayers = (videoId, insideModalPopup) => {
  try {
    const modalSelector = `.${window.GEVME.cssClassPrefix}-modal .${window.GEVME.cssClassPrefix}-modal-container .${window.GEVME.cssClassPrefix}-modal-content .${window.GEVME.cssClassPrefix}-template-showcase-block`;
    let selector =
      videoId && videoId.length > 0
        ? `.${window.GEVME.cssClassPrefix}-video-block-card-${videoId}`
        : `.${window.GEVME.cssClassPrefix}-video-block-card`;
    selector = insideModalPopup ? `${modalSelector} ${selector}` : selector;
    let videoElements = document.querySelectorAll(selector);
    if (videoElements && videoElements.length > 0) {
      const templateContentEl = document.querySelector(
        ".gevme-template-content"
      );
      const blocks = Object.values(window.GEVME.livepage.showcaseblocks);

      if (templateContentEl) {
        templateContentEl.onscroll = (e) => {
          const videoElementBlock = Array.from(videoElements).find(
            (vidBlockEl) => {
              const vidData = blocks.find(
                (block) => block.id === vidBlockEl.dataset.id
              );
              const vidEl = vidBlockEl.querySelector("video");
              return (
                vidData &&
                !vidData.backgroundCoverImageVisibility &&
                vidEl &&
                !vidEl.paused
              );
            }
          );
          if (
            videoElementBlock &&
            videoElementBlock.dataset &&
            videoElementBlock.getBoundingClientRect().top < 0
          ) {
            const videoId = videoElementBlock.dataset.id;
            const videoPlayerId = `gevme-video-${videoId}`;
            const videoPlayer = window.videojs.players[videoPlayerId];
            if (videoPlayer && videoPlayer.hasStarted_) {
              enterPictureInPicture(videoId, false);
            }
          }
        };
      }

      const updateVideoUrlTimestamp = (videoUrl) => {
        try {
          const videoLink = new URL(videoUrl);
          if (videoLink.search) {
            videoUrl += `&${
              window.GEVME.cssClassPrefix
            }Version=${new Date().getTime()}`;
          } else {
            videoUrl += `?${
              window.GEVME.cssClassPrefix
            }Version=${new Date().getTime()}`;
          }
          return videoUrl;
        } catch (error) {
          return videoUrl;
        }
      };
      const renderVideoPlayer = (
        videoId,
        videoUrl,
        videoTitle,
        useIvsPlayer,
        enableVideoQuality,
        enableAutoplay,
        currentVideoBlockConfig
      ) => {
        const isMuxStream = videoUrl.includes('mux.com')
        if (isMuxStream) {
          useIvsPlayer = false; // Override to use HTML5
          console.log('Mux stream detected - forcing HTML5 for subtitle support');
        }
        const contentBlock =
          window.GEVME.livepage.showcaseblocks[videoId] ||
          Object.values(window.GEVME.livepage.showcaseblocks).find(
            (block) => block.id === videoId
          );
        if (videoId && videoUrl && videoTitle) {
          if (useIvsPlayer && window.videojs && window.registerIVSTech) {
            const videoContainers = document.querySelectorAll(
              `${insideModalPopup ? `${modalSelector} ` : ""}.${
                window.GEVME.cssClassPrefix
              }-video-block-card-${videoId}`
            );
            if (videoContainers && videoContainers.length > 0) {
              window.registerIVSTech(window.videojs, {
                wasmWorker: `${process.env.REACT_APP_VENUE_SDK_BASE_URL}/scripts/amazon-ivs-wasmworker-v1.11.1.min.js`,
                wasmBinary: `${process.env.REACT_APP_VENUE_SDK_BASE_URL}/scripts/amazon-ivs-wasmworker.min-v1.11.1.wasm`,
              });

              if (enableVideoQuality && window.registerIVSQualityPlugin) {
                window.registerIVSQualityPlugin(window.videojs);
              }
              for (const videoContainer of videoContainers) {
                const videoElementParent = document.querySelector(
                  `div[data-content-block-id="${videoId}"]`
                );
                if (videoElementParent) {
                  const videoBlockElement = videoElementParent.querySelector(
                    ".gevme-video-block-content"
                  );
                  const headings =
                    videoElementParent.querySelectorAll(".gevme-block-title");
                  if (videoBlockElement && headings && headings.length) {
                    let headingHeight = 0;
                    let headingMargin = 0;
                    for (const heading of headings) {
                      if (heading?.offsetHeight > headingHeight) {
                        headingHeight = heading.offsetHeight;
                      }
                      const headingStyle = window.getComputedStyle(heading);
                      const newHeadingMargin =
                        parseInt(headingStyle?.marginTop || "0") +
                        parseInt(headingStyle?.marginBottom || "0");
                      if (newHeadingMargin > headingMargin) {
                        headingMargin = newHeadingMargin;
                      }
                    }
                    videoBlockElement.style = `height: calc(100% - ${
                      headingHeight + headingMargin
                    }px);`;
                  }
                }
                const videoElement = videoContainer.querySelector("video");
                if (videoElement) {
                  videoElement.style.opacity = 0;
                  console.log({ videoElement });
                  const players = (window.videojs.getAllPlayers() || []).filter(
                    (player) =>
                      player.id() ===
                      `${window.GEVME.cssClassPrefix}-video-${videoId}`
                  );
                  let player = players.length === 2 ? players[1] : players[0];
                  if (player && players.length === 2) {
                    player.dispose();
                  }
                  const videoSelector = insideModalPopup
                    ? `${modalSelector} .${window.GEVME.cssClassPrefix}-video-${videoId}`
                    : `.${window.GEVME.cssClassPrefix}-video-${videoId}`;
                  const videoOptions = {
                    techOrder: ["AmazonIVS", "html5"],
                    controlBar: {
                      download: false,
                      playToggle: { replay: false },
                      pictureInPictureToggle: true,
                      fullscreenToggle: true,
                    },
                    autoplay:
                      insideModalPopup || enableAutoplay ? "muted" : false,
                    controls: true,
                    playsinline: true,
                    muted: insideModalPopup ? false : enableAutoplay,
                    fluid: true,
                    loop: !!currentVideoBlockConfig?.enableLoop,
                    html5: {
                      nativeAudioTracks: false,
                      nativeVideoTracks: false,
                      nativeTextTracks: false,
                      hls: {
                        allowSeeksWithinUnsafeLiveWindow: false,
                        overrideNative: !window.videojs.browser.IS_ANY_SAFARI,
                        enableCEA708Captions: true,
                        enableCEA708CaptionsInHls: true,
                        captionServices: {
                          CC1: { language: "en", label: "English CC1" },
                          CC3: { language: "en", label: "English CC3" },
                          SERVICE1: { language: "en", label: "Service 1" },
                          SERVICE3: { language: "en", label: "Service 3" },
                          CC2: { language: "en", label: "English CC2" },
                          CC4: { language: "en", label: "English CC4" },
                          SERVICE2: { language: "en", label: "Service 2" },
                          SERVICE4: { language: "en", label: "Service 4" },
                        },
                      },
                      vhs: {
                        allowSeeksWithinUnsafeLiveWindow: false,
                        overrideNative: !window.videojs.browser.IS_ANY_SAFARI,
                        enableCEA708Captions: true,
                        enableCEA708CaptionsInHls: true,
                        useBandwidthFromLocalStorage: true,
                        captionServices: {
                          CC1: { language: "en", label: "English CC1" },
                          CC3: { language: "en", label: "English CC3" },
                          SERVICE1: { language: "en", label: "Service 1" },
                          SERVICE3: { language: "en", label: "Service 3" },
                          CC2: { language: "en", label: "English CC2" },
                          CC4: { language: "en", label: "English CC4" },
                          SERVICE2: { language: "en", label: "Service 2" },
                          SERVICE4: { language: "en", label: "Service 4" },
                        },
                      },
                    },
                    liveui: !window.videojs.browser.IS_ANY_SAFARI,
                    liveTracker: !window.videojs.browser.IS_ANY_SAFARI,
                    playbackRates: [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2],
                    crossorigin: "anonymous",
                    enableSmoothSeeking: true,
                    textTrackSettings: false,
                    // subsCapsButton: !contentBlock?.disableCaptionSelection,
                    subsCapsButton: true,
                  };

                  if (
                    window.GEVME.analytics.muxTrackingApiKey &&
                    window.GEVME.analytics.muxTrackingApiKey.length > 0
                  ) {
                    videoOptions.plugins = {
                      mux: {
                        debug: false,
                        disableCookies: true,
                        data: {
                          env_key: window.GEVME.analytics.muxTrackingApiKey,
                          player_name: videoTitle,
                          player_init_time: new Date().getTime(),
                          viewer_user_id: window.GEVME.user
                            ? window.GEVME.user.id
                            : "",
                          video_id: videoId,
                          video_title: videoTitle,
                          sub_property_id: window.GEVME.project
                            ? window.GEVME.project.id
                            : "",
                          view_session_id: window.GEVME.livepage
                            ? window.GEVME.livepage.id
                            : "",
                          page_url:
                            (window.GEVME.setting &&
                            window.GEVME.setting.customDomain &&
                            window.GEVME.setting.customDomain.length > 0
                              ? window.GEVME.setting.customDomain
                              : window.GEVME.setting.gevmeDomain) +
                            "/page/" +
                            (window.GEVME.livepage
                              ? window.GEVME.livepage.slug
                              : ""),
                        },
                      },
                    };
                  }

                  player = videojs(
                    document.querySelector(videoSelector),
                    videoOptions,
                    () => {
                      if (enableVideoQuality && player.enableIVSQualityPlugin) {
                        player.enableIVSQualityPlugin();
                      }
                      player.volume(
                        insideModalPopup ? 0.4 : enableAutoplay ? 0 : 0.4
                      );
                      player.src(updateVideoUrlTimestamp(videoUrl));
                      player.playsinline(true);
                      const videoJsPlayerElement =
                        videoContainer.querySelector("video");
                      const applyPortraitFromDimensions = (
                        videoWidth,
                        videoHeight
                      ) => {
                        const videoPlayerRoot = player.el();
                        if (!videoPlayerRoot || !videoWidth || !videoHeight) {
                          return false;
                        }
                        videoPlayerRoot.classList.toggle(
                          "vjs-portrait",
                          videoHeight > videoWidth
                        );
                        return true;
                      };
                      const updateVideoOrientationClass = () => {
                        const videoPlayerRoot = player.el();
                        if (!videoPlayerRoot) return false;

                        const techEl =
                          videoJsPlayerElement ||
                          videoPlayerRoot.querySelector(".vjs-tech") ||
                          (typeof player.tech === "function"
                            ? player.tech(true)?.el()
                            : null);
                        if (!techEl) return false;

                        let videoWidth = techEl.videoWidth;
                        let videoHeight = techEl.videoHeight;

                        if (
                          (!videoWidth || !videoHeight) &&
                          typeof player.videoWidth === "function"
                        ) {
                          const playerWidth = player.videoWidth();
                          const playerHeight = player.videoHeight();
                          if (playerWidth && playerHeight) {
                            videoWidth = playerWidth;
                            videoHeight = playerHeight;
                          }
                        }

                        if (!videoWidth || !videoHeight) return false;

                        return applyPortraitFromDimensions(
                          videoWidth,
                          videoHeight
                        );
                      };
                      const probeVideoOrientationFromUrl = () => {
                        try {
                          const probeVideo = document.createElement("video");
                          probeVideo.preload = "metadata";
                          probeVideo.muted = true;
                          probeVideo.playsInline = true;
                          probeVideo.setAttribute("playsinline", "");
                          probeVideo.src = updateVideoUrlTimestamp(videoUrl);
                          const cleanup = () => {
                            probeVideo.removeAttribute("src");
                            probeVideo.load();
                            probeVideo.remove();
                          };
                          probeVideo.addEventListener("loadedmetadata", () => {
                            applyPortraitFromDimensions(
                              probeVideo.videoWidth,
                              probeVideo.videoHeight
                            );
                            cleanup();
                          });
                          probeVideo.addEventListener("error", cleanup);
                        } catch (error) {
                          console.error(error);
                        }
                      };

                      const scheduleVideoOrientationUpdates = () => {
                        let orientationApplied = false;
                        const tryUpdateVideoOrientation = () => {
                          if (orientationApplied) return;
                          if (updateVideoOrientationClass()) {
                            orientationApplied = true;
                            player.off("timeupdate", onTimeUpdateForOrientation);
                          }
                        };
                        const onTimeUpdateForOrientation = () =>
                          tryUpdateVideoOrientation();

                        [
                          "loadedmetadata",
                          "loadeddata",
                          "resize",
                          "playing",
                        ].forEach((eventName) => {
                          player.on(eventName, tryUpdateVideoOrientation);
                        });

                        if (videoJsPlayerElement) {
                          videoJsPlayerElement.addEventListener(
                            "loadedmetadata",
                            tryUpdateVideoOrientation
                          );
                          videoJsPlayerElement.addEventListener(
                            "loadeddata",
                            tryUpdateVideoOrientation
                          );
                        }

                        player.on("timeupdate", onTimeUpdateForOrientation);
                        [0, 50, 150, 500, 1500, 3000].forEach((delay) => {
                          setTimeout(tryUpdateVideoOrientation, delay);
                        });
                      };

                      scheduleVideoOrientationUpdates();
                      probeVideoOrientationFromUrl();
                      if (insideModalPopup || enableAutoplay) {
                        player.on("loadeddata", () => {
                          player.play();
                        });
                      }
                      // Update the condition later
                      if (true || !contentBlock?.disableCaptionSelection) {
                        // Reusable function to enable caption tracks
                        const enableCaptionTracks = () => {
                          const tracks = player.textTracks();

                          console.log('Caption Detection:', {
                            totalTracks: tracks.length,
                            trackDetails: Array.from(tracks).map((t, i) => ({
                              index: i,
                              kind: t.kind,
                              label: t.label,
                              language: t.language,
                              mode: t.mode
                            }))
                          });

                          if (tracks && tracks.length > 0) {
                            for (let i = 0; i < tracks.length; i++) {
                              const track = tracks[i];
                              // Support subtitles, captions, and metadata tracks
                              if (
                                track.kind === "subtitles" ||
                                track.kind === "captions" ||
                                track.kind === "metadata"
                              ) {
                                track.mode = "showing";

                                // Listen to mode changes on this specific track
                                track.onmodechange = () => {
                                  console.log(`Track mode changed: ${track.label} -> ${track.mode}`);
                                };
                              }
                            }
                          }

                          // Safari-specific: enable native text tracks
                          if (window.videojs.browser.IS_ANY_SAFARI && videoJsPlayerElement) {
                            const nativeTracks = videoJsPlayerElement.textTracks;
                            if (nativeTracks) {
                              for (let i = 0; i < nativeTracks.length; i++) {
                                const track = nativeTracks[i];
                                if (track.kind === "subtitles" || track.kind === "captions") {
                                  track.mode = "showing";
                                }
                              }
                            }
                          }
                        };

                        // Listen to loadedmetadata (existing behavior)
                        player.on("loadedmetadata", () => {
                          console.log('Player Event: loadedmetadata');
                          enableCaptionTracks();
                        });

                        // Get text tracks reference
                        const textTracks = player.textTracks();

                        // Listen for tracks being added dynamically (CRITICAL for IVS)
                        textTracks.on('addtrack', (e) => {
                          const track = e.track;
                          console.log(`Caption Track Added: [${track.kind}] ${track.label} (${track.language})`);
                          enableCaptionTracks();
                        });

                        // Listen for track selection changes
                        textTracks.on('change', () => {
                          console.log('TextTrackList changed (track selected/deselected)');
                          enableCaptionTracks();
                        });

                        // One-time check after first play (catches late-loading captions)
                        player.one("playing", () => {
                          console.log('Player Event: playing (first time)');
                          enableCaptionTracks();
                        });
                      }
                      const adjustAspectRatio = () => {
                        if (insideModalPopup && videoJsPlayerElement) {
                          try {
                            const aspectRatio = Number(
                              (
                                videoJsPlayerElement.videoWidth /
                                videoJsPlayerElement.videoHeight
                              ).toFixed(2)
                            );
                            if (aspectRatio) {
                              videoJsPlayerElement.setAttribute(
                                "data-aspect-ratio",
                                aspectRatio
                              );
                              let height = videoJsPlayerElement.clientHeight;
                              const adjustedHeight =
                                videoJsPlayerElement.clientWidth / aspectRatio;
                              let width = videoJsPlayerElement.clientWidth;
                              const adjustedWidth =
                                aspectRatio * videoJsPlayerElement.clientHeight;
                              if (adjustedHeight > height) {
                                if (adjustedWidth <= width) {
                                  width = adjustedWidth;
                                }
                              } else {
                                height = adjustedHeight;
                              }
                              videoJsPlayerElement.style.height = `${height}px`;
                              videoJsPlayerElement.style.width = `${width}px`;
                            }
                          } catch (error) {
                            console.error(error);
                          }
                        }
                      };
                      player.on("fullscreenchange", () => {
                        if (videoJsPlayerElement) {
                          if (window.innerHeight === screen.height) {
                            videoJsPlayerElement.style.minHeight = "100%";
                            videoJsPlayerElement.style.minWidth = "100%";
                          } else {
                            videoJsPlayerElement.style.minHeight = "";
                            videoJsPlayerElement.style.minWidth = "";
                            if (insideModalPopup) {
                              adjustAspectRatio();
                            }
                          }
                        }
                      });
                      player.on("ready", () => {
                        // if (contentBlock?.disableCaptionSelection) {
                        //   const style = document.createElement("style");
                        //   style.innerHTML = `#gevme-video-${videoId} .vjs-subs-caps-button {
                        //                        display: none !important;
                        //                       }`;
                        //   document.head.appendChild(style);

                        //   const textTracks = player.textTracks();
                        //   for (let i = 0; i < textTracks.length; i++) {
                        //     textTracks[i].mode = "disabled";
                        //   }
                        // }
                        if (videoElement) {
                          const videoElementParent = document.querySelector(
                            `#gevme-video-${videoId}`
                          );
                          if (videoElementParent)
                            videoElementParent.style.opacity = 1;
                          videoElement.style.opacity = 1;
                        }
                      });

                      player.on("play", () => {
                        player.poster(null);
                        adjustAspectRatio();
                        handlePlayEvent(videoId, videoTitle, videoUrl, player);
                      });
                      player.on("error", (error) => console.error(error));
                      if (player.getIVSPlayer) {
                        player
                          .getIVSPlayer()
                          .addEventListener(
                            player.getIVSEvents().PlayerEventType.ERROR,
                            (error) => {
                              if (
                                [
                                  player.getIVSEvents().PlayerEventType.ERROR,
                                  player.getIVSEvents().PlayerEventType.GENERIC,
                                  player.getIVSEvents().PlayerEventType
                                    .AUTHORIZATION,
                                  player.getIVSEvents().PlayerEventType
                                    .NETWORK_UNAVAILABLE,
                                  player.getIVSEvents().PlayerEventType.NETWORK,
                                  player.getIVSEvents().PlayerEventType
                                    .NETWORK_IO,
                                  player.getIVSEvents().PlayerEventType
                                    .NOT_AVAILABLE,
                                  player.getIVSEvents().PlayerEventType
                                    .INVALID_DATA,
                                  player.getIVSEvents().PlayerEventType
                                    .INVALID_STATE,
                                  player.getIVSEvents().PlayerEventType
                                    .NO_SOURCE,
                                  player.getIVSEvents().PlayerEventType.TIMEOUT,
                                ].indexOf(error.type)
                              ) {
                                if (insideModalPopup || enableAutoplay) {
                                  player.pause();
                                }
                                setTimeout(() => {
                                  try {
                                    if (player) {
                                      player.src(
                                        updateVideoUrlTimestamp(videoUrl)
                                      );
                                      setTimeout(() => {
                                        try {
                                          if (
                                            insideModalPopup ||
                                            enableAutoplay
                                          ) {
                                            const errorPlayer = (
                                              window.videojs.getAllPlayers() ||
                                              []
                                            ).find(
                                              (errorPlayer) =>
                                                errorPlayer.id() ===
                                                `${window.GEVME.cssClassPrefix}-video-${videoId}`
                                            );
                                            if (errorPlayer) {
                                              errorPlayer.play();
                                            }
                                          }
                                        } catch (error) {
                                          console.error(error);
                                        }
                                      }, 5000);
                                    }
                                  } catch (error) {
                                    console.error(error);
                                  }
                                }, 10000);
                              }
                            }
                          );
                      }
                      if (videoJsPlayerElement) {
                        videoJsPlayerElement.setAttribute(
                          "data-matomo-resource",
                          videoUrl
                        );
                        videoJsPlayerElement.setAttribute(
                          "data-matomo-title",
                          videoTitle
                        );
                        setTimeout(() => {
                          if (
                            window.Matomo &&
                            window.Matomo.MediaAnalytics &&
                            window.Matomo.MediaAnalytics.enableMediaAnalytics &&
                            window.Matomo.MediaAnalytics.scanForMedia
                          ) {
                            window.Matomo.MediaAnalytics.enableMediaAnalytics();
                            window.Matomo.MediaAnalytics.scanForMedia();
                          }
                        }, 1000);
                        console.log("LiveStream", { contentBlock });
                        if (
                          contentBlock &&
                          contentBlock.id &&
                          contentBlock.id.length > 0 &&
                          contentBlock.type === "LiveStream" &&
                          contentBlock &&
                          contentBlock.streamingService &&
                          (contentBlock.streamingService === "customstream" ||
                            contentBlock.streamingService === "gevmelive")
                        ) {
                          videoJsPlayerElement.addEventListener(
                            "enterpictureinpicture",
                            () => {
                              if (
                                contentBlock &&
                                contentBlock.id &&
                                contentBlock.id.length > 0 &&
                                contentBlock.type === "LiveStream"
                              ) {
                                if (
                                  contentBlock.backgroundCoverImage &&
                                  contentBlock.backgroundCoverImage.length >
                                    0 &&
                                  contentBlock.backgroundCoverImageVisibility
                                ) {
                                  if (
                                    window.GEVME.utils.checkModalPopupVisibility(
                                      contentBlock.id
                                    )
                                  ) {
                                    window.GEVME.utils.closeModalPopup(
                                      contentBlock.name,
                                      true
                                    );
                                  }
                                }
                              }
                            }
                          );
                          videoJsPlayerElement.addEventListener(
                            "leavepictureinpicture",
                            () => {
                              if (
                                contentBlock.backgroundCoverImage &&
                                contentBlock.backgroundCoverImage.length > 0 &&
                                contentBlock.backgroundCoverImageVisibility
                              ) {
                                if (
                                  !window.GEVME.utils.checkModalPopupVisibility(
                                    contentBlock.id
                                  )
                                ) {
                                  window.GEVME.utils.openModalPopup(
                                    { contentBlock },
                                    true
                                  );
                                }
                              }
                            }
                          );
                          if (
                            !insideModalPopup &&
                            window.IntersectionObserver
                          ) {
                            new window.IntersectionObserver(
                              (entries) => {
                                entries.forEach((entry) => {
                                  if (!player.paused()) {
                                    if (entry.intersectionRatio <= 0.5) {
                                      if (!document.pictureInPictureElement) {
                                        window.GEVME.utils.enterPictureInPicture(
                                          contentBlock.id,
                                          insideModalPopup
                                        );
                                      }
                                    }
                                  }
                                });
                              },
                              {
                                threshold: [0, 0.25, 0.5, 0.75, 1],
                              }
                            ).observe(videoJsPlayerElement);
                          }
                        }
                      }
                    }
                  );
                }
              }
            }
          } else if (!useIvsPlayer && window.renderReactPlayer) {
            const videoContainers = document.querySelectorAll(
              `.${window.GEVME.cssClassPrefix}-video-block-card-${videoId}`
            );
            if (videoContainers && videoContainers.length > 0) {
              videoContainers.forEach((videoContainer) => {
                const contentBlock =
                  window.GEVME.livepage.showcaseblocks[videoId] ||
                  Object.values(window.GEVME.livepage.showcaseblocks).find(
                    (block) => block.id === videoId
                  );
                console.log({ contentBlock });
                var reactPlayer;
                var videoMetaTitle = videoTitle;
                var playerConfig = {
                  id: `player-${videoId}`,
                  url: videoUrl,
                  playing: insideModalPopup || enableAutoplay,
                  controls: true,
                  volume: insideModalPopup ? 0.4 : enableAutoplay ? 0 : 0.4,
                  playsinline: true,
                  muted: insideModalPopup ? false : enableAutoplay,
                  pip: false,
                  height: "100%",
                  width: "100%",
                  onPlay: () => {
                    console.log("onPlay", videoMetaTitle);
                    handlePlayEvent(videoId, videoMetaTitle, videoUrl);
                  },
                  onReady: async (playerObject) => {
                    try {
                      try {
                        const internalPlayer = playerObject.getInternalPlayer();
                        if (internalPlayer) {
                          const metaDataTitle = internalPlayer.getVideoData
                            ? await internalPlayer.getVideoData()?.title
                            : internalPlayer.getVideoTitle
                            ? await internalPlayer.getVideoTitle()
                            : "";
                          videoMetaTitle = metaDataTitle || videoTitle;
                        }

                        if (
                          (contentBlock &&
                            contentBlock.videoType === "youtube") ||
                          (contentBlock &&
                            contentBlock.type === "LiveStream" &&
                            contentBlock.streamingService === "youtube")
                        ) {
                          const metaDataTitle = contentBlock?.metadata?.title;
                          videoMetaTitle = metaDataTitle || videoMetaTitle;
                          console.log({ metaDataTitle, videoMetaTitle });
                          function onPlayerStateChange(event) {
                            console.log({ onPlayerStateChange: event });
                            if (event?.data === 1 || event?.data === 3) {
                              handlePlayEvent(
                                videoId,
                                videoMetaTitle,
                                videoUrl
                              );
                            }
                          }
                          const internalPlayerIframe = document.querySelector(
                            `#player-${videoId} iframe`
                          );
                          console.log({ internalPlayerIframe });
                          const internalPlayerIframeId =
                            internalPlayerIframe.id;
                          if (internalPlayerIframeId) {
                            console.log({ internalPlayerIframeId });
                            // eslint-disable-next-line no-undef, no-unused-vars
                            const youtubePlayer = new window.YT.Player(
                              internalPlayerIframeId,
                              {
                                events: {
                                  onStateChange: onPlayerStateChange,
                                },
                              }
                            );
                          }
                        }
                      } catch (error) {
                        console.error(error);
                      }

                      const iframe = videoContainer.querySelector("iframe");
                      if (iframe) {
                        iframe.setAttribute("data-matomo-resource", videoUrl);
                        iframe.setAttribute("data-matomo-title", videoTitle);
                      }
                      setTimeout(() => {
                        if (
                          window.Matomo &&
                          window.Matomo.MediaAnalytics &&
                          window.Matomo.MediaAnalytics.enableMediaAnalytics &&
                          window.Matomo.MediaAnalytics.scanForMedia
                        ) {
                          window.Matomo.MediaAnalytics.enableMediaAnalytics();
                          window.Matomo.MediaAnalytics.scanForMedia();
                        }
                      }, 1000);
                    } catch (error) {
                      console.error("Error in onReady:", error);
                    }
                  },
                  onError: (error) => {
                    console.error("onError", error);
                  },
                  config: {
                    file: {
                      attributes: {
                        "data-matomo-resource": videoUrl,
                        "data-matomo-title": videoTitle,
                        controlslist: "nodownload",
                      },
                    },
                    youtube: {
                      attributes: {
                        title: videoTitle,
                        "data-matomo-title": videoTitle,
                      },
                      playerVars: {
                        autoplay: enableAutoplay ? 1 : 0,
                        controls: 1,
                        enablejsapi: 1,
                        loop: 0,
                        playsinline: 1,
                      },
                    },
                    vimeo: {
                      attributes: {
                        title: videoTitle,
                        "data-matomo-title": videoTitle,
                      },
                      playerOptions: {
                        autoplay: enableAutoplay,
                        controls: true,
                        loop: false,
                        pip: false,
                        playsinline: true,
                      },
                    },
                    facebook: {
                      attributes: {
                        title: videoTitle,
                        "data-matomo-title": videoTitle,
                        "data-show-captions": true,
                        "data-autoplay": enableAutoplay,
                        "data-allowfullscreen": true,
                        "data-controls": true,
                      },
                    },
                  },
                  ref: (player) => (reactPlayer = player),
                };
                const style = document.createElement("style");
                style.innerHTML = `
                    .${window.GEVME.cssClassPrefix}-video-block-card-${videoId} video::-webkit-media-text-track-display {
                      top: 90% !important;
                      font-size: 14px !important;
                    }
                    .${window.GEVME.cssClassPrefix}-video-block-card-${videoId} video::cue {
                      font-size: 14px !important;
                      background-color: rgba(0, 0, 0, 0.8) !important;
                      color: #ffffff !important;
                      line-height: 1.5;
                      /* Add any other custom styles here */
                    }
                  `;
                document.head.appendChild(style);
                window.renderReactPlayer(videoContainer, playerConfig);
                window.reactPlayers[videoId] = reactPlayer;
              });
            }
          }
        }

        attachReactionEvent();
      };
      videoElements.forEach((videoElement) => {
        const currentVideoBlockConfig =
          blocks.find((block) => block.id === videoElement.dataset.id) || {};

        if (
          videoElement &&
          videoElement.dataset &&
          videoElement.dataset.id &&
          videoElement.dataset.id.length > 0 &&
          videoElement.dataset.url &&
          videoElement.dataset.url.length > 0 &&
          videoElement.dataset.title &&
          videoElement.dataset.title.length > 0
        ) {
          renderVideoPlayer(
            videoElement.dataset.id,
            videoElement.dataset.url,
            videoElement.dataset.title,
            videoElement.dataset.ivs === "true",
            videoElement.dataset.quality === "true",
            videoElement.dataset.autoplay === "true",
            currentVideoBlockConfig
          );
        }
      });
    }
  } catch (error) {
    console.error(error);
  }
};

const enableMatomoMediaTracking = () => {
  try {
    if (
      window.Matomo &&
      window.Matomo.MediaAnalytics &&
      window.Matomo.MediaAnalytics.enableMediaAnalytics &&
      window.Matomo.MediaAnalytics.isMediaAnalyticsEnabled &&
      window.Matomo.MediaAnalytics.scanForMedia
    ) {
      window.Matomo.MediaAnalytics.enableMediaAnalytics();
      if (window.Matomo.MediaAnalytics.isMediaAnalyticsEnabled()) {
        setTimeout(() => {
          window.Matomo.MediaAnalytics.scanForMedia();
        }, 5000);
      }
    }
  } catch (error) {
    console.error(error);
  }
};

const liveReloadFunction = (event, isPreview, _fullPagePreview) => {
  try {
    if (event && event.data) {
      let data = JSON.parse(event.data);
      const typeToCheck = isPreview ? "builder" : "livepage";
      if (data.type == typeToCheck && data.data) {
        if (data?.data?.setting) {
          //update GEVME settings
          window.GEVME.setting = {
            ...window.GEVME.setting,
            ...data.data.setting,
          };
          delete data?.data?.setting;
        }
        if (data.action === "created-block") {
          addBlockType(data.data.type.toLowerCase());
          window.GEVME.livepage.showcaseblocksweight.push(data.data.name);
          window.GEVME.livepage.showcaseblocks[data.data.name] = data.data;
          if (data?.data?.type === "RichText") return window.location.reload();
          const contentBlockWebComponents = document.querySelectorAll(
            `${window.GEVME.cssClassPrefix}-content-block`
          );
          if (
            contentBlockWebComponents &&
            contentBlockWebComponents.length > 0
          ) {
            for (let contentBlockWebComponent of contentBlockWebComponents) {
              const renderAll = contentBlockWebComponent.getAttribute("all");
              const contentBlockName =
                contentBlockWebComponent.getAttribute("name");
              let includedBlockNames =
                contentBlockWebComponent.getAttribute("include");
              let excludedBlockNames =
                contentBlockWebComponent.getAttribute("exclude");
              if (renderAll && renderAll.toString() === "true") {
                const rowContainer = contentBlockWebComponent.querySelector(
                  `.${window.GEVME.cssClassPrefix}-content-blocks-row.${window.GEVME.cssClassPrefix}-row`
                );
                if (rowContainer) {
                  if (
                    data.data.backgroundCoverImageVisibility &&
                    !!data.data.backgroundCoverImage
                  )
                    rowContainer.insertAdjacentHTML(
                      "beforeend",
                      `<div class="${window.GEVME.cssClassPrefix}-content-blocks-column ${window.GEVME.cssClassPrefix}-column ${data.data.type}" data-content-block-container="" data-content-block-container-id="${data.data.id}" data-content-block-container-name="${data.data.name}" data-content-block-container-type="${data.data.type}">${data.data.html}</div>`
                    );
                  else
                    rowContainer.insertAdjacentHTML(
                      "beforeend",
                      `<div class="${window.GEVME.cssClassPrefix}-content-blocks-column ${window.GEVME.cssClassPrefix}-column ${data.data.type}" data-content-block-container="" data-content-block-container-id="${data.data.id}" data-content-block-container-name="${data.data.name}" data-content-block-container-type="${data.data.type}">${data.data.htmlWithoutBackgroundCoverImage}</div>`
                    );
                }
              } else if (contentBlockName && contentBlockName.length > 0) {
                if (contentBlockName === data.data.name) {
                  const rowContainer = contentBlockWebComponent.querySelector(
                    `.${window.GEVME.cssClassPrefix}-content-blocks-row.${window.GEVME.cssClassPrefix}-row`
                  );
                  if (rowContainer) {
                    if (
                      data.data.backgroundCoverImageVisibility &&
                      !!data.data.backgroundCoverImage
                    )
                      rowContainer.insertAdjacentHTML(
                        "beforeend",
                        `<div class="${window.GEVME.cssClassPrefix}-content-blocks-column ${window.GEVME.cssClassPrefix}-column ${data.data.type}" data-content-block-container="" data-content-block-container-id="${data.data.id}" data-content-block-container-name="${data.data.name}" data-content-block-container-type="${data.data.type}">${data.data.html}</div>`
                      );
                    else
                      rowContainer.insertAdjacentHTML(
                        "beforeend",
                        `<div class="${window.GEVME.cssClassPrefix}-content-blocks-column ${window.GEVME.cssClassPrefix}-column ${data.data.type}" data-content-block-container="" data-content-block-container-id="${data.data.id}" data-content-block-container-name="${data.data.name}" data-content-block-container-type="${data.data.type}">${data.data.htmlWithoutBackgroundCoverImage}</div>`
                      );
                  }
                }
              } else if (includedBlockNames && includedBlockNames.length > 0) {
                includedBlockNames = includedBlockNames.trim().split(",");
                if (
                  includedBlockNames &&
                  includedBlockNames.length > 0 &&
                  includedBlockNames.indexOf(data.data.name) > -1
                ) {
                  const rowContainer = contentBlockWebComponent.querySelector(
                    `.${window.GEVME.cssClassPrefix}-content-blocks-row.${window.GEVME.cssClassPrefix}-row`
                  );
                  if (rowContainer) {
                    rowContainer.insertAdjacentHTML(
                      "beforeend",
                      `<div class="${window.GEVME.cssClassPrefix}-content-blocks-column ${window.GEVME.cssClassPrefix}-column ${data.data.type}" data-content-block-container="" data-content-block-container-id="${data.data.id}" data-content-block-container-name="${data.data.name}" data-content-block-container-type="${data.data.type}">${data.data.html}</div>`
                    );
                  }
                }
              } else if (excludedBlockNames && excludedBlockNames.length > 0) {
                excludedBlockNames = excludedBlockNames.trim().split(",");
                if (
                  excludedBlockNames &&
                  excludedBlockNames.length > 0 &&
                  excludedBlockNames.indexOf(data.data.name) === -1
                ) {
                  const rowContainer = contentBlockWebComponent.querySelector(
                    `.${window.GEVME.cssClassPrefix}-content-blocks-row.${window.GEVME.cssClassPrefix}-row`
                  );
                  if (rowContainer) {
                    rowContainer.insertAdjacentHTML(
                      "beforeend",
                      `<div class="${window.GEVME.cssClassPrefix}-content-blocks-column ${window.GEVME.cssClassPrefix}-column ${data.data.type}" data-content-block-container="" data-content-block-container-id="${data.data.id}" data-content-block-container-name="${data.data.name}" data-content-block-container-type="${data.data.type}">${data.data.html}</div>`
                    );
                  }
                }
              }
            }
          }
          document.dispatchEvent(
            new CustomEvent(`${window.GEVME.cssClassPrefix}-content-created`, {
              detail: { data: data.data },
            })
          );
          setTimeout(() => {
            window.GEVME.utils.retrieveAndRenderAllVideoBlockPlayers(
              data.data.id,
              false
            );
            window.GEVME.utils.enableImageSlideshowAutoScroll(data.data.name);
          }, 1000);
        } else if (data.action === "updated-block") {
          const oldBlock = window.GEVME.livepage.showcaseblocks[data.data.name];
          window.GEVME.livepage.showcaseblocks[data.data.name] = data.data;
          const contentBlockWebComponents = document.querySelectorAll(
            `${window.GEVME.cssClassPrefix}-content-block`
          );
          if (data?.data?.type === "RichText") return window.location.reload();
          if (
            contentBlockWebComponents &&
            contentBlockWebComponents.length > 0
          ) {
            for (let contentBlockWebComponent of contentBlockWebComponents) {
              const contentBlockContainers =
                contentBlockWebComponent.querySelectorAll(
                  `.${window.GEVME.cssClassPrefix}-content-blocks-row.${window.GEVME.cssClassPrefix}-row .${window.GEVME.cssClassPrefix}-content-blocks-column.${window.GEVME.cssClassPrefix}-column[data-content-block-container-id="${data.data.id}"]`
                );
              if (contentBlockContainers && contentBlockContainers.length > 0) {
                contentBlockContainers.forEach((contentBlockContainer) => {
                  contentBlockContainer.innerHTML = "";
                  contentBlockContainer.innerHTML = data.data.html;
                });
              }
            }
          }
          if (window.GEVME.utils.checkModalPopupVisibility(data.data.id)) {
            window.GEVME.utils.closeModalPopup(data.data.name);
            window.GEVME.utils.openModalPopup({ contentBlock: data.data });
          }
          document.dispatchEvent(
            new CustomEvent(`${window.GEVME.cssClassPrefix}-content-updated`, {
              detail: { data: { old: oldBlock, new: data.data } },
            })
          );
          setTimeout(() => {
            window.GEVME.utils.retrieveAndRenderAllVideoBlockPlayers(
              data.data.id,
              false
            );
            window.GEVME.utils.enableImageSlideshowAutoScroll(data.data.name);
          }, 1000);
        } else if (data.action === "deleted-block") {
          const contentBlock =
            window.GEVME.livepage.showcaseblocks[data.data.name];
          const blockIndex = window.GEVME.livepage.showcaseblocksweight.indexOf(
            data.data.name
          );
          window.GEVME.livepage.showcaseblocksweight.splice(blockIndex, 1);
          delete window.GEVME.livepage.showcaseblocks[data.data.name];

          const contentBlockWebComponents = document.querySelectorAll(
            `${window.GEVME.cssClassPrefix}-content-block`
          );
          if (
            contentBlockWebComponents &&
            contentBlockWebComponents.length > 0
          ) {
            for (let contentBlockWebComponent of contentBlockWebComponents) {
              const contentBlockContainers =
                contentBlockWebComponent.querySelectorAll(
                  `.${window.GEVME.cssClassPrefix}-content-blocks-row.${window.GEVME.cssClassPrefix}-row .${window.GEVME.cssClassPrefix}-content-blocks-column.${window.GEVME.cssClassPrefix}-column[data-content-block-container-id="${data.data.id}"]`
                );
              if (contentBlockContainers && contentBlockContainers.length > 0) {
                contentBlockContainers.forEach((contentBlockContainer) => {
                  contentBlockContainer.parentNode.removeChild(
                    contentBlockContainer
                  );
                });
              }
            }
          }
          if (window.GEVME.utils.checkModalPopupVisibility(contentBlock.id)) {
            window.GEVME.utils.closeModalPopup(contentBlock.name);
          }
          document.dispatchEvent(
            new CustomEvent(`${window.GEVME.cssClassPrefix}-content-deleted`, {
              detail: { data: data.data },
            })
          );
        } else if (data.action === "updated-header") {
          if (data?.data?.headerSettings) {
            window.GEVME.header = data.data.headerSettings;
            document.dispatchEvent(
              new CustomEvent(
                `${window.GEVME.cssClassPrefix}-page-header-updated`,
                { detail: window.GEVME.header }
              )
            );
          }
          const headerWidgetIndex = window.GEVME.widgets.findIndex(
            (widget) => widget.widget == "header"
          );
          if (headerWidgetIndex > -1) {
            window.GEVME.widgets[headerWidgetIndex] = data.data.settings;
            window.GEVME.setting.header.enabled = data.data.settings.enabled;
            document.dispatchEvent(
              new CustomEvent(`${window.GEVME.cssClassPrefix}-header-updated`, {
                detail: { data: data.data.settings },
              })
            );
            window.parent.postMessage(
              JSON.stringify({
                action: "gevme-json",
                data: JSON.stringify(window.GEVME),
              }),
              "*"
            );
          }
        } else if (data.action === "updated-livebar") {
          const livebarWidgetIndex = window.GEVME.widgets.findIndex(
            (widget) => widget.widget == "live-bar"
          );
          if (livebarWidgetIndex > -1) {
            const oldClosable = window.GEVME.widgets[
              livebarWidgetIndex
            ].inputs.find((input) => input.field === "closable");
            const newClosable = data.data.settings.inputs.find(
              (input) => input.field === "closable"
            );
            const oldOpenByDefault = window.GEVME.widgets[
              livebarWidgetIndex
            ].inputs.find((input) => input.field === "openByDefault");
            const newOpenByDefault = data.data.settings.inputs.find(
              (input) => input.field === "openByDefault"
            );
            const oldPushLivePageContent = window.GEVME.widgets[
              livebarWidgetIndex
            ].inputs.find((input) => input.field === "push_live_page_content");
            const newPushLivePageContent = data.data.settings.inputs.find(
              (input) => input.field === "push_live_page_content"
            );
            if (
              window.GEVME.widgets[livebarWidgetIndex].enabled !==
              data.data.settings.enabled
            ) {
              window.location.reload();
            } else if (
              window.GEVME.widgets[livebarWidgetIndex].position !==
              data.data.settings.position
            ) {
              window.location.reload();
            } else if (
              oldClosable &&
              newClosable &&
              oldClosable.value !== newClosable.value
            ) {
              window.location.reload();
            } else if (
              oldOpenByDefault &&
              newOpenByDefault &&
              oldOpenByDefault.value !== newOpenByDefault.value
            ) {
              window.location.reload();
            } else if (
              oldPushLivePageContent &&
              newPushLivePageContent &&
              oldPushLivePageContent.value !== newPushLivePageContent.value
            ) {
              window.location.reload();
            } else {
              window.GEVME.widgets[livebarWidgetIndex] = data.data.settings;
              window.GEVME.setting.livebar.enabled = data.data.settings.enabled;
              window.GEVME.setting.livebar.closable =
                data.data.settings.closable;
              window.GEVME.setting.livebar.positionLeft =
                data.data.settings.position === "left";
              window.GEVME.setting.livebar.positionRight =
                data.data.settings.position === "right";
              const livebarContainers = document.querySelectorAll(
                `${window.GEVME.cssClassPrefix}-live-bar`
              );
              if (livebarContainers && livebarContainers.length > 0) {
                livebarContainers.forEach((livebarContainer) => {
                  const livebarIframeContainer =
                    livebarContainer.querySelector("iframe");
                  if (livebarIframeContainer) {
                    livebarIframeContainer.src = livebarIframeContainer.src;
                  }
                });
              }
              document.dispatchEvent(
                new CustomEvent(
                  `${window.GEVME.cssClassPrefix}-livebar-updated`,
                  { detail: { data: data.data.settings } }
                )
              );
            }
          }
        } else if (data.action === "reorder") {
          if (data.data.order && data.data.order.length > 1) {
            data.data.order.forEach(({ name, order }) => {
              window.GEVME.livepage.showcaseblocks[name].order = order;
              const contentBlock = window.GEVME.livepage.showcaseblocks[name];
              const contentBlockWebComponents = document.querySelectorAll(
                `${window.GEVME.cssClassPrefix}-content-block`
              );
              if (
                contentBlockWebComponents &&
                contentBlockWebComponents.length > 0
              ) {
                for (let contentBlockWebComponent of contentBlockWebComponents) {
                  const renderSpecific =
                    contentBlockWebComponent.getAttribute("name");
                  if (
                    renderSpecific &&
                    renderSpecific.length > 0 &&
                    renderSpecific === contentBlock.name
                  ) {
                    const contentBlockContainer =
                      contentBlockWebComponent.querySelector(
                        `.${window.GEVME.cssClassPrefix}-content-blocks-row.${window.GEVME.cssClassPrefix}-row .${window.GEVME.cssClassPrefix}-content-blocks-column.${window.GEVME.cssClassPrefix}-column[data-content-block-container-id="${contentBlock.id}"]`
                      );
                    if (contentBlockContainer) {
                      contentBlockContainer.style.order = contentBlock.order;
                    }
                  } else {
                    const contentBlockContainers =
                      contentBlockWebComponent.querySelectorAll(
                        `.${window.GEVME.cssClassPrefix}-content-blocks-row.${window.GEVME.cssClassPrefix}-row .${window.GEVME.cssClassPrefix}-content-blocks-column.${window.GEVME.cssClassPrefix}-column[data-content-block-container-id="${contentBlock.id}"]`
                      );
                    if (
                      contentBlockContainers &&
                      contentBlockContainers.length > 0
                    ) {
                      contentBlockContainers.forEach(
                        (contentBlockContainer) => {
                          contentBlockContainer.style.order =
                            contentBlock.order;
                        }
                      );
                    }
                  }
                }
              }
            });
            document.dispatchEvent(
              new CustomEvent(
                `${window.GEVME.cssClassPrefix}-content-reorder`,
                { detail: { data: data.data } }
              )
            );
          }
        } else if (data.action === "updated-audio") {
          window.parent.postMessage(
            JSON.stringify({ action: data.action, data: data.data.settings }),
            "*"
          );
        } else if (data.action === "reaction") {
          const { reactionId, blockId } = data.data;
          const blocks = Object.values(window.GEVME.livepage.showcaseblocks);
          const block = blocks.filter((block) => block.id === blockId)[0];
          displayReaction({ reactionId, block });
        }
        document.dispatchEvent(
          new CustomEvent(`${window.GEVME.cssClassPrefix}-content`, {
            detail: { data: data },
          })
        );
      }
    }
  } catch (error) {
    console.error(error);
  }
};

const enableLiveReloadingWebSocket = (
  pageType = "live_page",
  isPreview,
  _fullPagePreview,
  webSocketUrl,
  webSocketToken
) => {
  try {
    if (pageType !== "website" || (pageType === "website" && isPreview)) {
      if (
        window.WebSocket &&
        webSocketUrl &&
        webSocketUrl.length > 0 &&
        webSocketToken &&
        webSocketToken.length > 0
      ) {
        const createWebsocketConnection = () => {
          window.renderWebSocket = new window.WebSocket(
            `${webSocketUrl}?token=${webSocketToken}${
              isPreview ? `&connectionType=preview` : ""
            }`
          );

          window.renderWebSocket.onopen = function (evt) {
            WEBSOCKET_TIME_OF_OPEN = new Date();
            console.log("Websocket Open: ", WEBSOCKET_TIME_OF_OPEN);
            window.localStorage.setItem(
              `${window.GEVME.project.id}-gevme-ws`,
              JSON.stringify([`${window.GEVME.livepage.slug}`])
            );

            console.info(
              `Render: Websocket open. Timestamp: ${
                evt.timeStamp
              } - ${Date.now()}`
            );
            // window.addEventListener('beforeunload', (event) => {

            // })
          };
          window.renderWebSocket.onerror = (error) => {
            console.error(error);
          };
          window.renderWebSocket.onclose = (evt) => {
            const timeOfClose = new Date();
            const diff = Math.abs(WEBSOCKET_TIME_OF_OPEN - timeOfClose);
            const seconds = Math.floor(diff / 1000);

            console.warn(
              `Render: Websocket ${evt.type} && ${timeOfClose}. Reason: ${
                evt.reason || "undefined"
              }`
            );

            if (
              (evt?.reason === "Going Away" ||
                evt?.code === 1001 ||
                evt?.code === "1001") &&
              seconds > 60
            ) {
              console.info(
                `Render: Websocket will re-establish right away! ${Date.now()}`
              );
              return createWebsocketConnection();
            } else if (seconds >= 180) {
              console.info(
                `Render: Websocket will re-establish normally! ${Date.now()}`
              );
              return createWebsocketConnection();
            } else {
              if (WEBSOCKET_RETRY_COUNT <= 4) {
                console.info(
                  `Render: Websocket will re-established with limited tries`
                );
                WEBSOCKET_RETRY_COUNT = WEBSOCKET_RETRY_COUNT + 1;
                if (WEBSOCKET_RETRY_COUNT.length) {
                  for (const r of WEBSOCKET_RETRY_COUNT) {
                    clearTimeout(r);
                  }
                }
                const retry = setTimeout(
                  () => createWebsocketConnection(),
                  1000 * WEBSOCKET_RETRY_COUNT
                );
                WEBSOCKET_RETRY_ARRAY.push(retry);
              } else
                console.log(
                  "Render: Websocket failed, need to refresh the page."
                );
            }
          };
          window.renderWebSocket.onmessage = (event) => {
            window.parent.postMessage(
              JSON.stringify({
                ...JSON.parse(event.data),
                from: "websocket",
                livepageId: window.GEVME.livepage.id,
                projectId: window.GEVME.project.id,
              }),
              "*"
            );

            const allWidgets = document.querySelectorAll('iframe[id*="Gevme"');
            if (allWidgets.length > 0) {
              allWidgets.forEach((widget) => {
                widget.contentWindow.postMessage(
                  JSON.stringify({
                    ...JSON.parse(event.data),
                    from: "websocket",
                    livepageId: window.GEVME.livepage.id,
                    projectId: window.GEVME.project.id,
                  }),
                  "*"
                );
              });
            }

            liveReloadFunction(event, isPreview, _fullPagePreview);
          };
        };

        createWebsocketConnection();
      }
    }
  } catch (error) {
    console.error(error);
  }
};

const enableImageSlideshowAutoScroll = (contentBlockName) => {
  try {
    const initSlider = (name, carouselElement) => {
      const contentBlock = window.GEVME.livepage.showcaseblocks[name];
      if (
        carouselElement &&
        contentBlock &&
        contentBlock.images &&
        contentBlock.images.length > 0
      ) {
        var imageSplide = new Splide(carouselElement, {
          perPage: contentBlock?.numberPerPage
            ? parseInt(contentBlock?.numberPerPage)
            : 1,
          type: "loop",
          rewind: true,
          lazy: false,
          gap: contentBlock?.spaceBetweenImages
            ? parseInt(contentBlock?.spaceBetweenImages)
            : 0,
          padding: 0,
          autoplay:
            contentBlock.autoScrollEnabled &&
            contentBlock.autoScrollTimeInterval > 0
              ? true
              : false,
          interval:
            contentBlock.autoScrollEnabled &&
            contentBlock.autoScrollTimeInterval > 0
              ? contentBlock.autoScrollTimeInterval * 1000
              : 0,
          pauseOnHover: true,
          pauseOnFocus: true,
          resetProgress: true,
          snap: true,
        }).mount();
      }
    };

    if (
      window.Splide &&
      window.GEVME &&
      window.GEVME.livepage &&
      window.GEVME.livepage.showcaseblocksweight &&
      window.GEVME.livepage.showcaseblocksweight.length > 0
    ) {
      if (contentBlockName && contentBlockName.length > 0) {
        const blockIndex =
          window.GEVME.livepage.showcaseblocks[contentBlockName]?.order;
        if (blockIndex > -1) {
          const contentBlockWebComponents = document.querySelectorAll(
            `${window.GEVME.cssClassPrefix}-content-block`
          );
          if (
            contentBlockWebComponents &&
            contentBlockWebComponents.length > 0
          ) {
            for (let contentBlockWebComponent of contentBlockWebComponents) {
              const renderSpecific =
                contentBlockWebComponent.getAttribute("name");
              if (
                renderSpecific &&
                renderSpecific.length > 0 &&
                renderSpecific ===
                  window.GEVME.livepage.showcaseblocks[contentBlockName].name
              ) {
                const contentBlockContainer =
                  contentBlockWebComponent.querySelector(
                    `[data-content-block-container-id="${window.GEVME.livepage.showcaseblocks[contentBlockName].id}"]`
                  );
                if (contentBlockContainer) {
                  const carouselElement = contentBlockContainer.querySelector(
                    `.${window.GEVME.cssClassPrefix}-carousel`
                  );
                  if (carouselElement) {
                    initSlider(contentBlockName, carouselElement);
                  }
                }
              } else {
                const contentBlockContainers =
                  contentBlockWebComponent.querySelectorAll(
                    `[data-content-block-container-id="${window.GEVME.livepage.showcaseblocks[contentBlockName].id}"]`
                  );
                if (
                  contentBlockContainers &&
                  contentBlockContainers.length > 0
                ) {
                  contentBlockContainers.forEach((contentBlockContainer) => {
                    const carouselElement = contentBlockContainer.querySelector(
                      `.${window.GEVME.cssClassPrefix}-carousel`
                    );
                    if (carouselElement) {
                      initSlider(contentBlockName, carouselElement);
                    }
                  });
                }
              }
            }
          }
        }
      } else {
        const imageBlockSlideshowElements = document.querySelectorAll(
          `.${window.GEVME.cssClassPrefix}-template-showcase-block.imageslideshow`
        );
        if (
          imageBlockSlideshowElements &&
          imageBlockSlideshowElements.length > 0
        ) {
          for (let i = 0; i < imageBlockSlideshowElements.length; i++) {
            const carouselElement = imageBlockSlideshowElements[
              i
            ].querySelector(`.${window.GEVME.cssClassPrefix}-carousel`);
            if (carouselElement) {
              const contentBlockName = imageBlockSlideshowElements[
                i
              ].getAttribute("data-content-block-name");
              if (contentBlockName && contentBlockName.length > 0) {
                initSlider(contentBlockName, carouselElement);
              }
            }
          }
        }
      }
    }
  } catch (error) {
    console.error(error);
  }
};

const checkPreviewPageLink = (link) => {
  try {
    if (link && link.length > 0 && link !== "#") {
      let pathname = new URL(link).href;
      let hostname = new URL(link).hostname;
      if (
        ["www.gevme.com", "gevme.com", "showcase-dev.gevme.com"].indexOf(
          hostname
        ) > -1
      ) {
        const pathnameSplit = pathname.split("gevme.com/page/");
        if (pathnameSplit.length > 1) {
          pathname = pathnameSplit[pathnameSplit.length - 1];
          if (pathname) {
            return pathname.includes("#") ? pathname.split("#")[0] : pathname;
          }
        }
      }
    }
    return null;
  } catch (error) {
    return null;
  }
};

const openModalPopup = (options, exitPIP = false) => {
  try {
    if (options) {
      const { html, height, width, backgroundColor, fullscreen } = options;
      const contentBlock = options.contentBlock
        ? options.contentBlock &&
          options.contentBlock.name &&
          options.contentBlock.name.length > 0
          ? window.GEVME.livepage.showcaseblocks[options.contentBlock.name]
          : null
        : options.contentBlockName && options.contentBlockName.length > 0
        ? window.GEVME.livepage.showcaseblocks[options.contentBlockName]
        : null;
      const selector = `.${window.GEVME.cssClassPrefix}-modal`;
      let gevmeModalCreated = false;

      if (contentBlock && contentBlock.id && contentBlock.id.length > 0) {
        if (
          contentBlock?.backgroundCoverImageDisablePopup &&
          !contentBlock?.backgroundCoverImageVisibility
        )
          return; // disable popup if backgroundCoverImageDisablePopup is true
        if (
          !document.querySelector(
            `${selector}[data-content-block-modal-id="${contentBlock.id}"]`
          )
        ) {
          document.body.insertAdjacentHTML(
            "beforeend",
            `<div class="${window.GEVME.cssClassPrefix}-modal" data-content-block-modal="" data-content-block-modal-id="${contentBlock.id}" data-content-block-modal-name="${contentBlock.name}" data-content-block-modal-type="${contentBlock.type}"><div class="${window.GEVME.cssClassPrefix}-modal-container"><div class="${window.GEVME.cssClassPrefix}-modal-header ${window.GEVME.cssClassPrefix}-modal-drag-handle"></div><div class="${window.GEVME.cssClassPrefix}-modal-content"></div></div></div>`
          );
          gevmeModalCreated = true;
        }
      }
      const gevmeModal = document.querySelector(
        contentBlock && contentBlock.id && contentBlock.id.length > 0
          ? `${selector}[data-content-block-modal-id="${contentBlock.id}"]`
          : `${selector}`
      );
      const gevmeModalHeaderButtons = [
        `<span class="${
          window.GEVME.cssClassPrefix
        }-modal-close" onclick="window.GEVME.utils.closeModalPopup(${
          contentBlock && contentBlock.name && contentBlock.name.length > 0
            ? `'${contentBlock.name}'`
            : ""
        })">×</span>`,
      ];
      if (gevmeModal) {
        if (exitPIP) {
          gevmeModal.classList.add("visible");
          return;
        }
        const gevmeModalContainer = gevmeModal.querySelector(
          `.${window.GEVME.cssClassPrefix}-modal-container`
        );
        const gevmeModalHeader = gevmeModal.querySelector(
          `.${window.GEVME.cssClassPrefix}-modal-container .${window.GEVME.cssClassPrefix}-modal-header`
        );
        let gevmeModalHeightOffset = "";
        let gevmeModalHeightPadding = "";
        let gevmeModalHeaderHeight = "";
        let isSafari = /^((?!chrome|android).)*safari/i.test(
          navigator.userAgent
        );

        if (contentBlock && contentBlock.id && contentBlock.id.length > 0) {
          if (gevmeModalContainer) {
            gevmeModalHeightPadding = window
              .getComputedStyle(gevmeModalContainer, null)
              .getPropertyValue("padding");
            gevmeModalHeightOffset = `${gevmeModalHeightPadding} + ${gevmeModalHeightPadding}`;
          }
          if (gevmeModalHeader) {
            gevmeModalHeaderHeight = window
              .getComputedStyle(gevmeModalHeader, null)
              .getPropertyValue("height");
            gevmeModalHeightOffset =
              gevmeModalHeightOffset + " + " + gevmeModalHeaderHeight;
          }
          const contentBlockHeight = contentBlock.isInsideParentContentBlock
            ? "100%"
            : contentBlock.fitHeightToContent ||
              contentBlock.blockHeight === "fit-content"
            ? isSafari
              ? "auto"
              : "fit-content"
            : contentBlock.blockHeight && contentBlock.blockHeight.length > 0
            ? `calc(${contentBlock.blockHeight} + (${gevmeModalHeightOffset}))`
            : "100%";
          const contentBlockWidth =
            contentBlock.blockWidth && contentBlock.blockWidth.length > 0
              ? contentBlock.blockWidth !== "min-content" &&
                contentBlock.blockWidth !== "max-content" &&
                contentBlock.blockWidth !== "fit-content"
                ? contentBlock.blockWidth
                : "auto"
              : "100%";
          const desktopStyleContainer = gevmeModal.querySelector(
            'style[data-style="desktop"]'
          );
          const desktopStyle = `
                        .${window.GEVME.cssClassPrefix}-modal.visible[data-content-block-modal-id="${contentBlock.id}"] {
                            height: 400px !important;
                        }
                    `;
          if (desktopStyleContainer) {
            desktopStyleContainer.innerHTML = desktopStyle;
          } else {
            gevmeModal.insertAdjacentHTML(
              "afterbegin",
              `
                            <style type="text/css" data-style="desktop">
                                ${desktopStyle}
                            </style>
                        `
            );
            if (
              contentBlock.fitHeightToContent ||
              contentBlock.blockHeight === "fit-content"
            ) {
              gevmeModal.insertAdjacentHTML(
                "beforeend",
                `
                                <style type="text/css" data-style="desktop-default">
                                    .${window.GEVME.cssClassPrefix}-modal.visible[data-content-block-modal-id="${contentBlock.id}"] .${window.GEVME.cssClassPrefix}-modal-container .${window.GEVME.cssClassPrefix}-modal-content gevme-content-block .gevme-content-blocks-row .gevme-content-blocks-column[data-content-block-container-id="${contentBlock.id}"] .gevme-template-showcase-block[data-content-block-id="${contentBlock.id}"] {
                                        height: 550px;
                                    }
                                </style>
                            `
              );
            }
          }
          if (contentBlock.tabletBreakpoints) {
            const contentBlockTabletHeight =
              contentBlock.isInsideParentContentBlock
                ? "100%"
                : contentBlock.tabletBreakpoints.fitHeightToContent ||
                  contentBlock.tabletBreakpoints.blockHeight === "fit-content"
                ? isSafari
                  ? "auto"
                  : "fit-content"
                : contentBlock.tabletBreakpoints.blockHeight &&
                  contentBlock.tabletBreakpoints.blockHeight.length > 0
                ? `calc(${contentBlock.tabletBreakpoints.blockHeight} + (${gevmeModalHeightOffset}))`
                : contentBlockHeight;
            const contentBlockTabletWidth =
              contentBlock.tabletBreakpoints.blockWidth &&
              contentBlock.tabletBreakpoints.blockWidth.length > 0
                ? contentBlock.tabletBreakpoints.blockWidth !== "min-content" &&
                  contentBlock.tabletBreakpoints.blockWidth !== "max-content" &&
                  contentBlock.tabletBreakpoints.blockWidth !== "fit-content"
                  ? contentBlock.tabletBreakpoints.blockWidth
                  : "auto"
                : contentBlockWidth;
            const tabletStyleContainer = gevmeModal.querySelector(
              'style[data-style="tablet"]'
            );
            const tabletStyle = `
                            @media screen and (min-width: 576px) and (max-width: 991px) {
                                .${window.GEVME.cssClassPrefix}-modal.visible[data-content-block-modal-id="${contentBlock.id}"] {
                                    height: 400px !important;
                                }
                            }
                        `;
            if (tabletStyleContainer) {
              tabletStyleContainer.innerHTML = tabletStyle;
            } else {
              gevmeModal.insertAdjacentHTML(
                "beforeend",
                `
                                <style type="text/css" data-style="tablet">
                                    ${tabletStyle}
                                </style>
                            `
              );
            }
          }
          if (
            (!contentBlock.tabletBreakpoints &&
              (contentBlock.fitHeightToContent ||
                contentBlock.blockHeight === "fit-content")) ||
            (contentBlock.tabletBreakpoints &&
              (contentBlock.tabletBreakpoints.fitHeightToContent ||
                contentBlock.tabletBreakpoints.blockHeight === "fit-content"))
          ) {
            gevmeModal.insertAdjacentHTML(
              "beforeend",
              `
                            <style type="text/css" data-style="tablet-default">
                                @media screen and (min-width: 576px) and (max-width: 991px) {
                                    .${window.GEVME.cssClassPrefix}-modal.visible[data-content-block-modal-id="${contentBlock.id}"] .${window.GEVME.cssClassPrefix}-modal-container .${window.GEVME.cssClassPrefix}-modal-content gevme-content-block .gevme-content-blocks-row .gevme-content-blocks-column[data-content-block-container-id="${contentBlock.id}"] .gevme-template-showcase-block[data-content-block-id="${contentBlock.id}"] {
                                        height: 450px;
                                    }
                                }
                            </style>
                        `
            );
          }
          if (contentBlock.mobileBreakpoints) {
            const contentBlockMobileHeight =
              contentBlock.isInsideParentContentBlock
                ? "100%"
                : contentBlock.mobileBreakpoints.fitHeightToContent ||
                  contentBlock.mobileBreakpoints.blockHeight === "fit-content"
                ? isSafari
                  ? "auto"
                  : "fit-content"
                : contentBlock.mobileBreakpoints.blockHeight &&
                  contentBlock.mobileBreakpoints.blockHeight.length > 0
                ? `calc(${contentBlock.mobileBreakpoints.blockHeight} + (${gevmeModalHeightOffset}))`
                : contentBlockHeight;
            const contentBlockMobileWidth =
              contentBlock.mobileBreakpoints.blockWidth &&
              contentBlock.mobileBreakpoints.blockWidth.length > 0
                ? contentBlock.mobileBreakpoints.blockWidth !== "min-content" &&
                  contentBlock.mobileBreakpoints.blockWidth !== "max-content" &&
                  contentBlock.mobileBreakpoints.blockWidth !== "fit-content"
                  ? contentBlock.mobileBreakpoints.blockWidth
                  : "auto"
                : contentBlockWidth;
            const mobileStyleContainer = gevmeModal.querySelector(
              'style[data-style="mobile"]'
            );
            const mobileStyle = `
                            @media screen and (max-width: 575px) {
                                .${window.GEVME.cssClassPrefix}-modal.visible[data-content-block-modal-id="${contentBlock.id}"] {
                                    height: 400px !important;
                                }
                            }
                        `;
            if (mobileStyleContainer) {
              mobileStyleContainer.innerHTML = mobileStyle;
            } else {
              gevmeModal.insertAdjacentHTML(
                "beforeend",
                `
                                <style type="text/css" data-style="mobile">
                                    ${mobileStyle}
                                </style>
                            `
              );
            }
          }
          if (
            (!contentBlock.mobileBreakpoints &&
              contentBlock.fitHeightToContent) ||
            (contentBlock.mobileBreakpoints &&
              (contentBlock.mobileBreakpoints.fitHeightToContent ||
                contentBlock.mobileBreakpoints.blockHeight === "fit-content"))
          ) {
            gevmeModal.insertAdjacentHTML(
              "beforeend",
              `
                            <style type="text/css" data-style="mobile-default">
                                @media screen and (max-width: 575px) {
                                    .${window.GEVME.cssClassPrefix}-modal.visible[data-content-block-modal-id="${contentBlock.id}"] .${window.GEVME.cssClassPrefix}-modal-container .${window.GEVME.cssClassPrefix}-modal-content gevme-content-block .gevme-content-blocks-row .gevme-content-blocks-column[data-content-block-container-id="${contentBlock.id}"] .gevme-template-showcase-block[data-content-block-id="${contentBlock.id}"] {
                                        height: 250px;
                                    }
                                }
                            </style>
                        `
            );
          }
        } else {
          gevmeModal.style.height = height ? `${height}px` : "auto";
          gevmeModal.style.width = width ? `${width}px` : "auto";
        }
        const sanitizeHeadingForMatomo = (text) => {
          const headingElement = document.createElement("div");
          headingElement.innerHTML = text;
          return headingElement.innerText;
        };
        if (gevmeModalContainer) {
          gevmeModalContainer.style.backgroundColor = backgroundColor
            ? backgroundColor
            : "#000000";
          const gevmeModalContent = gevmeModalContainer.querySelector(
            `.${window.GEVME.cssClassPrefix}-modal-content`
          );
          if (gevmeModalContent) {
            if (html && html.length > 0) {
              gevmeModalContent.innerHTML = html;
            } else if (
              contentBlock &&
              contentBlock.id &&
              contentBlock.id.length > 0
            ) {
              gevmeModalContent.innerHTML = `<${window.GEVME.cssClassPrefix}-content-block name="${contentBlock.name}"><div class="${window.GEVME.cssClassPrefix}-content-blocks-row ${window.GEVME.cssClassPrefix}-row"><div class="${window.GEVME.cssClassPrefix}-content-blocks-column ${window.GEVME.cssClassPrefix}-column ${contentBlock.type}" data-content-block-container="" data-content-block-container-id="${contentBlock.id}" data-content-block-container-name="${contentBlock.name}" data-content-block-container-type="${contentBlock.type}">${contentBlock.htmlWithoutBackgroundCoverImage}</div></div></${window.GEVME.cssClassPrefix}-content-block>`;
              if (
                (contentBlock.type === "Pdf" ||
                  contentBlock.type === "Resources") &&
                contentBlock.resources &&
                contentBlock.resources.length === 1 &&
                contentBlock.resources[0].link &&
                contentBlock.resources[0].link.length > 0 &&
                contentBlock.resources[0].type === "pdf"
              ) {
                gevmeModalContent.innerHTML = `<div class="${window.GEVME.cssClassPrefix}-modal-pdf-canvas"><div class="pdfViewer"></div></div>`;
                if (contentBlock.headingVisibility && contentBlock.heading) {
                  gevmeModalContent.innerHTML = `<div class="${window.GEVME.cssClassPrefix}-block-title">${contentBlock.heading}</div><div class="${window.GEVME.cssClassPrefix}-modal-pdf-canvas"><div class="pdfViewer"></div></div>`;
                }
                gevmeModalContent.classList.add(
                  `${window.GEVME.cssClassPrefix}-modal-content-pdf`
                );
                if (contentBlock.enableBookmark) {
                  gevmeModalHeaderButtons.push(
                    `<span class="${
                      window.GEVME.cssClassPrefix
                    }-modal-action-button bookmark${
                      contentBlock.resources[0].isBookmarked ? " active" : ""
                    }" style="display: flex;" onclick="window.GEVME.xhr.toggleResourceBookmark('${
                      contentBlock.name
                    }', '${
                      contentBlock.resources[0].id
                    }', false)" data-track-content="" data-content-name="${
                      contentBlock.heading && contentBlock.heading.length > 0
                        ? sanitizeHeadingForMatomo(contentBlock.heading)
                        : sanitizeHeadingForMatomo(contentBlock.title)
                    }" data-content-piece="${
                      contentBlock.id
                    }" data-content-target="${
                      contentBlock.resources[0].link
                    }"><svg width="14" height="18" viewBox="0 0 14 18" title="Bookmark" class="gevme-resources-block-bookmark-icon"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-475.000000, -3036.000000)" stroke="#000000" stroke-width="2"><g transform="translate(475.000000, 3036.000000)"><path d="M12,1 C12.2761476,1 12.5261481,1.11192293 12.7071108,1.29288566 C12.8880765,1.47385129 13,1.72385514 13,2 L13,2 L13,16.381966 L7,13.381966 L1,16.381966 L1,2 C1,1.7238575 1.11192863,1.47385743 1.29289303,1.29289303 C1.47385743,1.11192863 1.7238575,1 2,1 L2,1 Z"></path></g></g></g></svg></span>`
                  );
                }
                gevmeModalHeaderButtons.push(
                  `<span class="${
                    window.GEVME.cssClassPrefix
                  }-modal-action-button download" style="display: flex;" onclick="window.open('${
                    contentBlock.resources[0].link
                  }')" data-track-content="" data-content-name="${
                    contentBlock.heading && contentBlock.heading.length > 0
                      ? sanitizeHeadingForMatomo(contentBlock.heading)
                      : sanitizeHeadingForMatomo(contentBlock.title)
                  }" data-content-piece="${
                    contentBlock.id
                  }" data-content-target="${
                    contentBlock.resources[0].link
                  }"><svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.9395 16.6015C11.9578 16.6197 11.9775 16.6374 11.9975 16.6539C12.0067 16.6614 12.0164 16.668 12.0258 16.675C12.0371 16.6835 12.0481 16.6922 12.0598 16.7C12.0711 16.7075 12.0827 16.7141 12.0943 16.721C12.1049 16.7273 12.1153 16.734 12.1262 16.7398C12.138 16.7461 12.1501 16.7514 12.1622 16.7571C12.1736 16.7625 12.1848 16.7682 12.1964 16.773C12.2081 16.7778 12.22 16.7818 12.2319 16.786C12.2444 16.7905 12.2568 16.7953 12.2695 16.7991C12.2814 16.8027 12.2935 16.8054 12.3055 16.8084C12.3185 16.8117 12.3314 16.8153 12.3447 16.8179C12.3586 16.8207 12.3726 16.8223 12.3866 16.8243C12.3981 16.826 12.4095 16.8282 12.4212 16.8293C12.4732 16.8345 12.5255 16.8345 12.5775 16.8293C12.5892 16.8282 12.6006 16.826 12.6121 16.8243C12.6261 16.8223 12.6401 16.8207 12.654 16.8179C12.6673 16.8153 12.6802 16.8117 12.6932 16.8084C12.7052 16.8054 12.7173 16.8027 12.7292 16.7991C12.742 16.7953 12.7543 16.7905 12.7668 16.786C12.7787 16.7817 12.7906 16.7778 12.8023 16.773C12.8139 16.7682 12.8252 16.7625 12.8365 16.7571C12.8486 16.7514 12.8607 16.7461 12.8725 16.7398C12.8834 16.734 12.8938 16.7273 12.9044 16.721C12.916 16.7141 12.9277 16.7075 12.9389 16.7C12.9506 16.6922 12.9616 16.6835 12.9729 16.675C12.9823 16.668 12.992 16.6614 13.0012 16.6539C13.0212 16.6374 13.0404 16.6202 13.0587 16.6019L18.6008 11.0598C18.91 10.7506 18.91 10.2494 18.6008 9.94021C18.2917 9.63105 17.7904 9.63105 17.4812 9.94021L13.291 14.1304V3.79165C13.291 3.35443 12.4993 3 12.4993 3C12.4993 3 11.7077 3.35443 11.7077 3.79165V14.1304L7.51747 9.94021C7.20832 9.63105 6.70704 9.63105 6.39788 9.94021C6.08873 10.2494 6.08873 10.7506 6.39788 11.0598L11.9395 16.6015Z" fill="white"/><path d="M18.041 19.417H6.95767C6.52045 19.417 6.16602 19.7714 6.16602 20.2086C6.16602 20.6459 6.52045 21.0003 6.95767 21.0003H18.041C18.4782 21.0003 18.8327 20.6459 18.8327 20.2087C18.8327 19.7715 18.4782 19.417 18.041 19.417Z" fill="white"/></svg></span>`
                );
                try {
                  const canvasContainer = gevmeModalContent.querySelector(
                    `.${window.GEVME.cssClassPrefix}-modal-pdf-canvas`
                  );
                  if (canvasContainer) {
                    const pdfjsLib = window.pdfjsLib;
                    const pdfjsViewer = window.pdfjsViewer;
                    pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.REACT_APP_VENUE_SDK_BASE_URL}/scripts/pdf.worker-2.9.359.min.js`;
                    const eventBus = new pdfjsViewer.EventBus();
                    const pdfLinkService = new pdfjsViewer.PDFLinkService({
                      eventBus,
                    });
                    const pdfFindController = new pdfjsViewer.PDFFindController(
                      { eventBus, linkService: pdfLinkService }
                    );
                    const pdfScriptingManager =
                      new pdfjsViewer.PDFScriptingManager({
                        eventBus,
                        sandboxBundleSrc: `${process.env.REACT_APP_VENUE_SDK_BASE_URL}/scripts/pdf.sandbox-2.9.359.min.js`,
                      });
                    const pdfViewer = new pdfjsViewer.PDFViewer({
                      container: canvasContainer,
                      eventBus,
                      linkService: pdfLinkService,
                      findController: pdfFindController,
                      scriptingManager: pdfScriptingManager,
                      enableScripting: true,
                    });
                    pdfLinkService.setViewer(pdfViewer);
                    pdfScriptingManager.setViewer(pdfViewer);
                    eventBus.on("pagesinit", function () {
                      pdfViewer.currentScale = 1;
                    });
                    eventBus.on("scalechanging", function () {
                      pdfViewer.currentScale = 1;
                    });
                    eventBus.on("pagechanging", function () {
                      pdfViewer.currentScale = 1;
                    });
                    const loadingTask = pdfjsLib.getDocument({
                      url: contentBlock.resources[0].link,
                      withCredentials: true,
                      cMapUrl:
                        "https://cdn.jsdelivr.net/npm/pdfjs-dist@2.9.359/cmaps/",
                      cMapPacked: true,
                    });
                    loadingTask.promise.then(function (pdfDocument) {
                      pdfViewer.setDocument(pdfDocument);
                      pdfLinkService.setDocument(pdfDocument, null);
                      setTimeout(() => {
                        if (!fullscreen) {
                          const x = (
                            (document.body.clientWidth -
                              gevmeModal.clientWidth) /
                            2
                          ).toFixed(2);
                          const y = (
                            (document.body.clientHeight -
                              gevmeModal.clientHeight) /
                            2
                          ).toFixed(2);
                          gevmeModal.style.transform = `translate(${x}px, ${y}px)`;
                          gevmeModal.setAttribute("data-x", x);
                          gevmeModal.setAttribute("data-y", y);
                        }
                      }, 0);
                    });
                  }
                } catch (error) {
                  console.error(error);
                }
              } else if (
                contentBlock.type === "LiveStream" &&
                contentBlock.livestreamUrl &&
                contentBlock.livestreamUrl.length > 0 &&
                (contentBlock.streamingService === "customstream" ||
                  contentBlock.streamingService === "gevmelive")
              ) {
                gevmeModalHeaderButtons.push(
                  `<span class="${window.GEVME.cssClassPrefix}-modal-action-button pip" style="display: flex;" onclick="window.GEVME.utils.enterPictureInPicture('${contentBlock.id}', true)"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="path-1-outside-1" maskUnits="userSpaceOnUse" x="2.57715" y="2.64258" width="19" height="15" fill="black"><rect fill="white" x="2.57715" y="2.64258" width="19" height="15"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3.57715 5.64258C3.57715 4.53801 4.47258 3.64258 5.57715 3.64258H18.8795C19.984 3.64258 20.8795 4.53801 20.8795 5.64258V14.6193C20.8795 15.7239 19.984 16.6193 18.8795 16.6193H14.0238V15.6926H19.0139C19.5662 15.6926 20.0139 15.2449 20.0139 14.6926V5.56969C20.0139 5.01741 19.5662 4.56969 19.0139 4.56969H5.44184C4.88956 4.56969 4.44184 5.01741 4.44184 5.56969V9.33543H3.57715V5.64258Z"/></mask><path fill-rule="evenodd" clip-rule="evenodd" d="M3.57715 5.64258C3.57715 4.53801 4.47258 3.64258 5.57715 3.64258H18.8795C19.984 3.64258 20.8795 4.53801 20.8795 5.64258V14.6193C20.8795 15.7239 19.984 16.6193 18.8795 16.6193H14.0238V15.6926H19.0139C19.5662 15.6926 20.0139 15.2449 20.0139 14.6926V5.56969C20.0139 5.01741 19.5662 4.56969 19.0139 4.56969H5.44184C4.88956 4.56969 4.44184 5.01741 4.44184 5.56969V9.33543H3.57715V5.64258Z" fill="white"/><path d="M14.0238 16.6193H13.8238V16.8193H14.0238V16.6193ZM14.0238 15.6926V15.4926H13.8238V15.6926H14.0238ZM4.44184 9.33543V9.53543H4.64184V9.33543H4.44184ZM3.57715 9.33543H3.37715V9.53543H3.57715V9.33543ZM5.57715 3.44258C4.36212 3.44258 3.37715 4.42755 3.37715 5.64258H3.77715C3.77715 4.64847 4.58304 3.84258 5.57715 3.84258V3.44258ZM18.8795 3.44258H5.57715V3.84258H18.8795V3.44258ZM21.0795 5.64258C21.0795 4.42755 20.0945 3.44258 18.8795 3.44258V3.84258C19.8736 3.84258 20.6795 4.64847 20.6795 5.64258H21.0795ZM21.0795 14.6193V5.64258H20.6795V14.6193H21.0795ZM18.8795 16.8193C20.0945 16.8193 21.0795 15.8343 21.0795 14.6193H20.6795C20.6795 15.6134 19.8736 16.4193 18.8795 16.4193V16.8193ZM14.0238 16.8193H18.8795V16.4193H14.0238V16.8193ZM13.8238 15.6926V16.6193H14.2238V15.6926H13.8238ZM14.0238 15.8926H19.0139V15.4926H14.0238V15.8926ZM19.0139 15.8926C19.6767 15.8926 20.2139 15.3554 20.2139 14.6926H19.8139C19.8139 15.1344 19.4558 15.4926 19.0139 15.4926V15.8926ZM20.2139 14.6926V5.56969H19.8139V14.6926H20.2139ZM20.2139 5.56969C20.2139 4.90695 19.6767 4.36969 19.0139 4.36969V4.76969C19.4558 4.76969 19.8139 5.12786 19.8139 5.56969H20.2139ZM19.0139 4.36969H5.44184V4.76969H19.0139V4.36969ZM5.44184 4.36969C4.7791 4.36969 4.24184 4.90695 4.24184 5.56969H4.64184C4.64184 5.12786 5.00001 4.76969 5.44184 4.76969V4.36969ZM4.24184 5.56969V9.33543H4.64184V5.56969H4.24184ZM3.57715 9.53543H4.44184V9.13543H3.57715V9.53543ZM3.37715 5.64258V9.33543H3.77715V5.64258H3.37715Z" fill="white" mask="url(#path-1-outside-1)"/><mask id="path-3-outside-2" maskUnits="userSpaceOnUse" x="-0.364746" y="10.6035" width="13" height="10" fill="black"><rect fill="white" x="-0.364746" y="10.6035" width="13" height="10"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2.63525 11.6035C1.53068 11.6035 0.635254 12.4989 0.635254 13.6035V18.2547C0.635254 19.3592 1.53068 20.2547 2.63525 20.2547H9.88177C10.9863 20.2547 11.8818 19.3592 11.8818 18.2547V13.6035C11.8818 12.4989 10.9863 11.6035 9.88177 11.6035H2.63525ZM2.19814 12.2214C1.64586 12.2214 1.19814 12.6691 1.19814 13.2214V18.6367C1.19814 19.189 1.64586 19.6367 2.19815 19.6367H10.32C10.8723 19.6367 11.32 19.189 11.32 18.6367V13.2214C11.32 12.6691 10.8723 12.2214 10.32 12.2214H2.19814Z"/></mask><path fill-rule="evenodd" clip-rule="evenodd" d="M2.63525 11.6035C1.53068 11.6035 0.635254 12.4989 0.635254 13.6035V18.2547C0.635254 19.3592 1.53068 20.2547 2.63525 20.2547H9.88177C10.9863 20.2547 11.8818 19.3592 11.8818 18.2547V13.6035C11.8818 12.4989 10.9863 11.6035 9.88177 11.6035H2.63525ZM2.19814 12.2214C1.64586 12.2214 1.19814 12.6691 1.19814 13.2214V18.6367C1.19814 19.189 1.64586 19.6367 2.19815 19.6367H10.32C10.8723 19.6367 11.32 19.189 11.32 18.6367V13.2214C11.32 12.6691 10.8723 12.2214 10.32 12.2214H2.19814Z" fill="white"/><path d="M0.935254 13.6035C0.935254 12.6646 1.69637 11.9035 2.63525 11.9035V11.3035C1.365 11.3035 0.335254 12.3333 0.335254 13.6035H0.935254ZM0.935254 18.2547V13.6035H0.335254V18.2547H0.935254ZM2.63525 19.9547C1.69637 19.9547 0.935254 19.1936 0.935254 18.2547H0.335254C0.335254 19.5249 1.365 20.5547 2.63525 20.5547V19.9547ZM9.88177 19.9547H2.63525V20.5547H9.88177V19.9547ZM11.5818 18.2547C11.5818 19.1936 10.8206 19.9547 9.88177 19.9547V20.5547C11.152 20.5547 12.1818 19.5249 12.1818 18.2547H11.5818ZM11.5818 13.6035V18.2547H12.1818V13.6035H11.5818ZM9.88177 11.9035C10.8207 11.9035 11.5818 12.6646 11.5818 13.6035H12.1818C12.1818 12.3333 11.152 11.3035 9.88177 11.3035V11.9035ZM2.63525 11.9035H9.88177V11.3035H2.63525V11.9035ZM1.49814 13.2214C1.49814 12.8348 1.81155 12.5214 2.19814 12.5214V11.9214C1.48017 11.9214 0.898145 12.5034 0.898145 13.2214H1.49814ZM1.49814 18.6367V13.2214H0.898145V18.6367H1.49814ZM2.19815 19.3367C1.81155 19.3367 1.49814 19.0233 1.49814 18.6367H0.898145C0.898145 19.3547 1.48018 19.9367 2.19815 19.9367V19.3367ZM10.32 19.3367H2.19815V19.9367H10.32V19.3367ZM11.02 18.6367C11.02 19.0233 10.7066 19.3367 10.32 19.3367V19.9367C11.038 19.9367 11.62 19.3547 11.62 18.6367H11.02ZM11.02 13.2214V18.6367H11.62V13.2214H11.02ZM10.32 12.5214C10.7066 12.5214 11.02 12.8348 11.02 13.2214H11.62C11.62 12.5034 11.038 11.9214 10.32 11.9214V12.5214ZM2.19814 12.5214H10.32V11.9214H2.19814V12.5214Z" fill="white" mask="url(#path-3-outside-2)"/></svg></span>`
                );
                window.GEVME.utils.exitPictureInPicture(contentBlock);
              } else if (
                contentBlock.type === "Link" &&
                contentBlock &&
                contentBlock.enableLink &&
                contentBlock.link &&
                contentBlock.link.length > 0
              ) {
                const previewLink = window.GEVME.utils.checkPreviewPageLink(
                  contentBlock.link
                );
                if (
                  window.GEVME.isPreview &&
                  previewLink &&
                  previewLink.length > 0
                ) {
                  window.GEVME.utils.switchVenueBuilderPreview(
                    previewLink,
                    contentBlock.openInNewWindow
                  );
                } else {
                  const linkBlockElement = document.createElement("a");
                  linkBlockElement.setAttribute("href", contentBlock.link);
                  linkBlockElement.setAttribute(
                    "target",
                    contentBlock.openInNewWindow ? "_blank" : "_top"
                  );
                  linkBlockElement.style.display = "none";
                  document.body.appendChild(linkBlockElement);
                  linkBlockElement.click();
                  document.body.removeChild(linkBlockElement);
                }
                return;
              }
              if (
                gevmeModalCreated &&
                [
                  "Meeting",
                  "Agenda",
                  "Sponsor",
                  "Product",
                  "Search",
                  "Html",
                  "Livestream",
                ].indexOf(contentBlock.type) > -1
              ) {
                const iframe = gevmeModal.querySelector("iframe");
                if (iframe) {
                  window.addEventListener("blur", () => {
                    if ((document.activeElement = iframe)) {
                      try {
                        let openModalPopups = document.querySelectorAll(
                          `.${window.GEVME.cssClassPrefix}-modal.visible`
                        );
                        if (openModalPopups && openModalPopups.length > 0) {
                          openModalPopups = Array.from(openModalPopups);
                          openModalPopups = openModalPopups.sort((a, b) =>
                            Number(
                              window
                                .getComputedStyle(a, null)
                                .getPropertyValue("z-index")
                            ) >
                            Number(
                              window
                                .getComputedStyle(b, null)
                                .getPropertyValue("z-index")
                            )
                              ? -1
                              : 1
                          );
                          const zIndex = Number(
                            window
                              .getComputedStyle(openModalPopups[0], null)
                              .getPropertyValue("z-index")
                          );
                          gevmeModal.style.zIndex = `${zIndex + 1}`;
                        }
                      } catch (error) {
                        console.error(error);
                      }
                    }
                  });
                }
              }
            } else {
              return;
            }
            if (gevmeModalHeader) {
              gevmeModalHeader.innerHTML = gevmeModalHeaderButtons.join("");
            }
            gevmeModal.classList.add("visible");
            if (fullscreen) {
              gevmeModal.classList.add("fullscreen");
            }
            if (contentBlock && contentBlock.id && contentBlock.id.length > 0) {
              if (!fullscreen && !gevmeModal.style.transform) {
                const x = (
                  (document.body.clientWidth - gevmeModal.clientWidth) /
                  2
                ).toFixed(2);
                const y = (
                  (document.body.clientHeight - gevmeModal.clientHeight) /
                  2
                ).toFixed(2);
                gevmeModal.style.transform = `translate(${x}px, ${y}px)`;
                gevmeModal.setAttribute("data-x", x);
                gevmeModal.setAttribute("data-y", y);
              }
              setTimeout(() => {
                window.GEVME.utils.retrieveAndRenderAllVideoBlockPlayers(
                  contentBlock.id,
                  true
                );
                window.GEVME.utils.enableImageSlideshowAutoScroll(
                  contentBlock.name
                );
              }, 1000);
            }
            document.body.style.overscrollBehaviorY = "contain";
            gevmeModal.style.zIndex = 10000;
            if (!fullscreen && window.interact) {
              setTimeout(() => {
                let selector = `.${window.GEVME.cssClassPrefix}-modal.visible`;
                selector =
                  contentBlock && contentBlock.id && contentBlock.id.length > 0
                    ? `${selector}[data-content-block-modal-id="${contentBlock.id}"]`
                    : `${selector}`;
                window
                  .interact(selector)
                  .resizable({
                    // resize from all edges and corners
                    edges: { left: true, right: true, bottom: true, top: true },
                    listeners: {
                      move(event) {
                        const target = event.target;
                        let x = parseFloat(target.getAttribute("data-x")) || 0;
                        let y = parseFloat(target.getAttribute("data-y")) || 0;
                        // update the element's style
                        target.style.width = event.rect.width + "px";
                        target.style.height = event.rect.height + "px";
                        // translate when resizing from top or left edges
                        x += event.deltaRect.left;
                        y += event.deltaRect.top;
                        target.style.transform =
                          "translate(" + x + "px," + y + "px)";
                        target.setAttribute("data-x", x);
                        target.setAttribute("data-y", y);
                        if (
                          contentBlock &&
                          contentBlock.id &&
                          contentBlock.id.length > 0 &&
                          contentBlock.type === "LiveStream" &&
                          contentBlock &&
                          contentBlock.streamingService &&
                          (contentBlock.streamingService === "customstream" ||
                            contentBlock.streamingService === "gevmelive")
                        ) {
                          const videoContainer = gevmeModal.querySelector(
                            `.${window.GEVME.cssClassPrefix}-video-block-card-${contentBlock.id}`
                          );
                          const videoJsPlayerElement =
                            videoContainer.querySelector("video");
                          if (
                            videoJsPlayerElement &&
                            videoJsPlayerElement.networkState > 0
                          ) {
                            const aspectRatio = Number(
                              videoJsPlayerElement.getAttribute(
                                "data-aspect-ratio"
                              )
                            );
                            if (aspectRatio) {
                              let height = videoContainer.clientHeight;
                              const adjustedHeight =
                                videoContainer.clientWidth / aspectRatio;
                              let width = videoContainer.clientWidth;
                              const adjustedWidth =
                                aspectRatio * videoContainer.clientHeight;
                              if (adjustedHeight > height) {
                                if (adjustedWidth <= width) {
                                  width = adjustedWidth;
                                }
                              } else {
                                height = adjustedHeight;
                              }
                              videoJsPlayerElement.style.height = `${height}px`;
                              videoJsPlayerElement.style.width = `${width}px`;
                            }
                          }
                        }
                        if (
                          contentBlock &&
                          contentBlock.id &&
                          contentBlock.id.length > 0
                        ) {
                          const desktopDefaultStyle = gevmeModal.querySelector(
                            `style[data-style="desktop-default"]`
                          );
                          if (desktopDefaultStyle) {
                            desktopDefaultStyle.parentNode.removeChild(
                              desktopDefaultStyle
                            );
                          }
                          const tabletDefaultStyle = gevmeModal.querySelector(
                            `style[data-style="tablet-default"]`
                          );
                          if (tabletDefaultStyle) {
                            tabletDefaultStyle.parentNode.removeChild(
                              tabletDefaultStyle
                            );
                          }
                          const mobileDefaultStyle = gevmeModal.querySelector(
                            `style[data-style="mobile-default"]`
                          );
                          if (mobileDefaultStyle) {
                            mobileDefaultStyle.parentNode.removeChild(
                              mobileDefaultStyle
                            );
                          }
                        }
                      },
                    },
                    modifiers: [
                      // keep the edges inside the parent
                      interact.modifiers.restrictEdges({ outer: "parent" }),
                      // minimum size
                      interact.modifiers.restrictSize({
                        min: { width: 100, height: 100 },
                      }),
                    ],
                    inertia: true,
                  })
                  .draggable({
                    listeners: {
                      move: (event) => {
                        const target = event.target;
                        // keep the dragged position in the data-x/data-y attributes
                        const x =
                          (parseFloat(target.getAttribute("data-x")) || 0) +
                          event.dx;
                        const y =
                          (parseFloat(target.getAttribute("data-y")) || 0) +
                          event.dy;
                        // translate the element
                        target.style.transform =
                          "translate(" + x + "px, " + y + "px)";
                        // update the posiion attributes
                        target.setAttribute("data-x", x);
                        target.setAttribute("data-y", y);
                      },
                    },
                    inertia: true,
                    modifiers: [
                      interact.modifiers.restrictRect({
                        restriction: "parent",
                        endOnly: true,
                      }),
                    ],
                    allowFrom: `.${window.GEVME.cssClassPrefix}-modal-drag-handle`,
                  })
                  .on("tap", () => {
                    try {
                      let openModalPopups = document.querySelectorAll(
                        `.${window.GEVME.cssClassPrefix}-modal.visible`
                      );
                      if (openModalPopups && openModalPopups.length > 0) {
                        openModalPopups = Array.from(openModalPopups);
                        openModalPopups = openModalPopups.sort((a, b) =>
                          Number(
                            window
                              .getComputedStyle(a, null)
                              .getPropertyValue("z-index")
                          ) >
                          Number(
                            window
                              .getComputedStyle(b, null)
                              .getPropertyValue("z-index")
                          )
                            ? -1
                            : 1
                        );
                        const zIndex = Number(
                          window
                            .getComputedStyle(openModalPopups[0], null)
                            .getPropertyValue("z-index")
                        );
                        gevmeModal.style.zIndex = `${zIndex + 1}`;
                      }
                    } catch (error) {
                      console.error(error);
                    }
                  })
                  .preventDefault("always");
              }, 1000);
            }
          }
        }

        if (contentBlock?.type === "ImageList" && initImageListPhotoGallery)
          initImageListPhotoGallery();

        attachReactionEvent();
      }
    }
  } catch (error) {
    console.error(error);
  }
};

const closeModalPopup = (contentBlockName, inPIP = false) => {
  try {
    const contentBlock = window.GEVME.livepage.showcaseblocks[contentBlockName];
    const selector = `.${window.GEVME.cssClassPrefix}-modal.visible`;
    const gevmeModal = document.querySelector(
      contentBlockName && contentBlockName.length > 0
        ? `${selector}[data-content-block-modal-id="${contentBlock.id}"]`
        : `${selector}`
    );
    if (gevmeModal) {
      const gevmeModalContainer = gevmeModal.querySelector(
        `.${window.GEVME.cssClassPrefix}-modal-container`
      );
      if (gevmeModalContainer) {
        gevmeModalContainer.style.backgroundColor = "#000000";
        const gevmeModalContent = gevmeModalContainer.querySelector(
          `.${window.GEVME.cssClassPrefix}-modal-content`
        );
        if (gevmeModalContent) {
          if (inPIP) {
            gevmeModal.classList.remove("visible");
            return;
          }
          if (contentBlockName && contentBlockName.length > 0) {
            if (
              contentBlock.type === "LiveStream" &&
              contentBlock &&
              contentBlock.livestreamUrl &&
              contentBlock.livestreamUrl.length > 0
            ) {
              if (
                contentBlock.streamingService === "customstream" ||
                contentBlock.streamingService === "gevmelive"
              ) {
                const player = (window.videojs.getAllPlayers() || []).find(
                  (player) =>
                    player.id() ===
                    `${window.GEVME.cssClassPrefix}-video-${contentBlockName}`
                );
                if (player) {
                  player.pause();
                }
              } else {
                gevmeModalContent.innerHTML = "";
              }
            }
          } else {
            gevmeModalContent.innerHTML = "";
          }
        }
      }
      gevmeModal.classList.remove("visible");
      gevmeModal.remove();
      document.body.style.overscrollBehaviorY = "";
    }
  } catch (error) {
    console.error(error);
  }
};

const checkModalPopupVisibility = (contentBlockId) => {
  try {
    const selector = `.${window.GEVME.cssClassPrefix}-modal.visible`;
    const gevmeModal = document.querySelector(
      contentBlockId && contentBlockId.length > 0
        ? `${selector}[data-content-block-modal-id="${contentBlockId}"]`
        : `${selector}`
    );
    if (gevmeModal) {
      return true;
    }
    return false;
  } catch (error) {
    console.error(error);
  }
};

const logoutUser = (enableConfirmation) => {
  try {
    localStorage.clear();
    if (window.parent) {
      window.parent.postMessage(
        JSON.stringify({ action: "logout", enableConfirmation }),
        "*"
      );
    }
  } catch (error) {
    console.error(error);
  }
};

const closeOwnWindow = () => {
  try {
    if (window.parent) {
      window.parent.postMessage(
        JSON.stringify({ action: "close-own-window" }),
        "*"
      );
    }
  } catch (error) {
    console.error(error);
  }
};

const switchVenueBuilderPreview = (slug, openInNewWindow) => {
  try {
    if (window.GEVME.isPreview && slug && slug.length > 0) {
      window.parent.postMessage(
        JSON.stringify({ menuAction: "switch", target: slug, openInNewWindow }),
        "*"
      );
      window.parent.parent.postMessage(
        JSON.stringify({ menuAction: "switch", target: slug, openInNewWindow }),
        "*"
      );
    }
  } catch (error) {
    console.error(error);
  }
};

const enterPictureInPicture = (contentBlockId, insideModalPopup) => {
  try {
    const videoElement = document.querySelector(
      `${
        insideModalPopup
          ? `.${window.GEVME.cssClassPrefix}-modal .${window.GEVME.cssClassPrefix}-modal-container .${window.GEVME.cssClassPrefix}-modal-content .${window.GEVME.cssClassPrefix}-template-showcase-block `
          : ""
      }.${window.GEVME.cssClassPrefix}-video-block-card-${contentBlockId} video`
    );
    if (
      videoElement &&
      videoElement.requestPictureInPicture &&
      videoElement.networkState > 0
    ) {
      videoElement.requestPictureInPicture();
    }
  } catch (error) {
    if (
      error.name !== "InvalidStateError" &&
      error.name !== "NotAllowedError"
    ) {
      console.error(error);
    }
  }
};

const exitPictureInPicture = (_contentBlock) => {
  if (
    document.pictureInPictureEnabled &&
    document.exitPictureInPicture &&
    document.pictureInPictureElement
  ) {
    document.exitPictureInPicture();
  }
};

const establishPreviewConnection = ({
  callback = null,
  enableDefault = false,
}) => {
  try {
    window.onmessage = (event) => {
      if (isValidDomain(event.origin, window?.GEVME?.setting?.customDomain)) {
        const data = JSON.parse(event?.data);
        if (data?.type === "preview-events" && callback) callback(data);
      }
    };
  } catch (error) {
    console.error(error);
  }
};

const sendPreviewAction = (payload) => {
  try {
    window?.top?.postMessage(JSON.stringify(payload), "*");
  } catch (error) {
    console.error(error);
  }
};

const renderPublicPageGenericLoginScreen = () => {
  try {
    if (
      ["607fe5ae4f6c5d003fc78892"].indexOf(window.GEVME.project.id) > -1 &&
      window.GEVME.livepage.isPublic
    ) {
      if (!localStorage.getItem(`${window.GEVME.project.id}-isLoggedIn`)) {
        const html = `
                    <div style="background-image: url(${window.GEVME.setting.backgroundImage}); background-repeat: no-repeat; background-size: cover; background-position: center; display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; width: 100%; padding: 96px;">
                        <div style="height: 100%; min-height: 400px; max-height: 500px; width: 100%; min-width: 300px; max-width: 400px; box-shadow: rgb(0 0 0 / 20%) 0px 15px 35px 0px; border-radius: 10px; padding: 30px 20px; background-color: white; display: flex; align-items: center; flex-direction: column; justify-content: center;">
                            <div style="text-align: center; margin-bottom: 20px;">
                                <h2 style="font-size: 32px; font-weight: 400; line-height: 1.4; margin: 0px;">請輸入密碼</h2>
                            </div>
                            <div style="width: 100%; padding: 0px 20px; display: flex; align-items: center; justify-content: center; flex-direction: column; margin-bottom: 20px;">
                                <form style="display: flex; height: 100%; width: 100%; align-items: center; justify-content: center; flex-direction: column; margin-bottom: 20px;" onsubmit="window.GEVME.utils.submitPublicPageGenericLoginScreen(event);">
                                    <label for="password" style="width: 100%; box-sizing: border-box;">
                                        <input type="password" name="password" placeholder="密碼" autocapitalize="none" autocomplete="off" required="true" style="height: 48px; width: 100%; display: block; padding: 10px 20px; box-sizing: border-box; font-size: 20px; border-radius: 5px; border: 1px solid rgb(204, 204, 204); outline: none; margin-bottom: 25px;" />
                                    </label>
                                    <button type="submit" style="height: 48px; width: 100%; font-size: 18px; color: #fff; border: 1px solid rgb(82, 65, 209); background: rgb(82, 65, 209); margin-bottom: 0; border-radius: 5px; cursor: pointer;">登入</button>
                                </form>
                                <a href="https://www.gevme.com" target="_blank" rel="noopener noreferrer nofollow">
                                    <img src="https://files-myxp.gevme.com/templates/assets/GEVME_logo.svg" alt="GEVME" style="height: 25px;">
                                </a>
                            </div>
                        </div>
                    </div>
                `;
        window.GEVME.utils.openModalPopup({
          html,
          height: "100%",
          width: "100%",
          fullscreen: true,
        });
      }
    }
  } catch (error) {
    console.error(error);
  }
};

const submitPublicPageGenericLoginScreen = (event) => {
  try {
    event.preventDefault();
    if (document.querySelector('input[type="password"]').value === "0526") {
      localStorage.setItem(`${window.GEVME.project.id}-isLoggedIn`, "true");
      if (window.GEVME.utils.checkModalPopupVisibility()) {
        window.GEVME.utils.closeModalPopup();
      }
    } else {
      localStorage.removeItem(`${window.GEVME.project.id}-isLoggedIn`);
      alert("Incorrect username or password. Please try again");
    }
  } catch (error) {
    console.error(error);
  }
};

const handlePreviewNavMenuItemClick = (
  event,
  navMenuItemElement,
  openInNewWindow
) => {
  if (
    window.GEVME.isPreview &&
    navMenuItemElement &&
    navMenuItemElement.dataset &&
    navMenuItemElement.dataset.menuPreview &&
    navMenuItemElement.dataset.menuPreview.length > 0
  ) {
    event.preventDefault();
    window.GEVME.utils.switchVenueBuilderPreview(
      navMenuItemElement.dataset.menuPreview,
      openInNewWindow
    );
  }
};
const openSpeakerModal = (speakerId, blockId = "") => {
  const payload = {
    action: "open-speaker-modal",
    data: { speakerId, blockId, blockSetting: {} },
  };
  const speakerData = window.GEVME.speakers.find(
    (speaker) => speaker.id === speakerId
  );
  const activity = ADOBE_DATA_LAYER.clickSpeaker(
    speakerData?.firstname && speakerData?.lastname
      ? `${speakerData?.firstname} ${speakerData?.lastname}`
      : `${speakerData?.firstname || speakerData?.lastname}`
  );

  trackAdobeAnalytics(activity);

  window.parent.postMessage(JSON.stringify(payload), "*");
  window.postMessage(JSON.stringify(payload), "*");
};

const toggleResourceBookmark = async (
  contentBlockName,
  resourceId,
  skipNetwork
) => {
  try {
    const contentBlockIndex =
      window.GEVME.livepage.showcaseblocks[contentBlockName].order;
    if (contentBlockIndex > -1) {
      const contentBlock =
        window.GEVME.livepage.showcaseblocks[contentBlockName];
      if (
        contentBlock &&
        contentBlock.resources &&
        contentBlock.resources.length > 0
      ) {
        const resourceIndex = contentBlock.resources.findIndex(
          (resource) => resource.id === resourceId
        );
        if (resourceIndex > -1) {
          const resource = contentBlock.resources[resourceIndex];
          const postMessagePayload = {
            projectId: window.GEVME.project.id,
            showcaseId: window.GEVME.livepage.id,
            showcaseSlug: window.GEVME.livepage.slug,
            isPreview: window.GEVME.isPreview,
            contentBlockId: contentBlock.id,
            contentBlockName: contentBlock.name,
            resourceBlockId: contentBlock.id,
            resourceId: resource.id,
            isBookmarked: resource.isBookmarked,
          };
          let bookmarkButtons = document.querySelectorAll(
            `.${window.GEVME.cssClassPrefix}-resources-block .${window.GEVME.cssClassPrefix}-resources-block-card .${window.GEVME.cssClassPrefix}-resources-block-card-body .${window.GEVME.cssClassPrefix}-resources-block-row.${window.GEVME.cssClassPrefix}-resources-block-row-${resource.id} .${window.GEVME.cssClassPrefix}-resources-block-column.${window.GEVME.cssClassPrefix}-resources-block-button .${window.GEVME.cssClassPrefix}-resources-block-bookmark-button`
          );
          if (!bookmarkButtons || bookmarkButtons.length === 0) {
            bookmarkButtons = document.querySelectorAll(
              `.${window.GEVME.cssClassPrefix}-modal[data-content-block-modal-id="${contentBlock.id}"] .${window.GEVME.cssClassPrefix}-modal-container .${window.GEVME.cssClassPrefix}-modal-header .${window.GEVME.cssClassPrefix}-modal-action-button.bookmark`
            );
          }
          if (bookmarkButtons && bookmarkButtons.length > 0) {
            bookmarkButtons.forEach((bookmarkButton) => {
              bookmarkButton.setAttribute("disabled", "");
            });
            const postMessageClient =
              new window.GEVME.utils.WindowPostMessageProxy({
                logMessages: false,
                suppressWarnings: true,
                name: window.GEVME.cssClassPrefix,
              });
            const result = skipNetwork
              ? { status: true }
              : await postMessageClient.postMessage(window.parent, {
                  xhr: "toggleResourceBookmark",
                  ...postMessagePayload,
                });
            if (typeof result.status === "boolean") {
              if (result.status) {
                window.GEVME.livepage.showcaseblocks[
                  contentBlockName
                ].resources[resourceIndex].isBookmarked =
                  !resource.isBookmarked;
                bookmarkButtons.forEach((bookmarkButton) => {
                  if (result.status) {
                    bookmarkButton.classList.toggle("active");
                  }
                  bookmarkButton.removeAttribute("disabled");
                });
                if (result.status) {
                  const contentBlockWebComponents = document.querySelectorAll(
                    `${window.GEVME.cssClassPrefix}-content-block`
                  );
                  if (
                    contentBlockWebComponents &&
                    contentBlockWebComponents.length > 0
                  ) {
                    for (let contentBlockWebComponent of contentBlockWebComponents) {
                      const contentBlockContainers =
                        contentBlockWebComponent.querySelectorAll(
                          `.${window.GEVME.cssClassPrefix}-content-blocks-row.${window.GEVME.cssClassPrefix}-row .${window.GEVME.cssClassPrefix}-content-blocks-column.${window.GEVME.cssClassPrefix}-column[data-content-block-container-id="${contentBlock.id}"]`
                        );
                      if (
                        contentBlockContainers &&
                        contentBlockContainers.length > 0
                      ) {
                        contentBlockContainers.forEach(
                          (contentBlockContainer) => {
                            const contentBlockContainerElement =
                              document.createElement(
                                `${window.GEVME.cssClassPrefix}-content-block`
                              );
                            contentBlockContainerElement.innerHTML =
                              contentBlockContainer.innerHTML;
                            window.GEVME.livepage.showcaseblocks[
                              contentBlockName
                            ].htmlWithoutBackgroundCoverImage =
                              contentBlockContainerElement.innerHTML;
                          }
                        );
                      }
                    }
                  }
                }
                const livebarContainers = document.querySelectorAll(
                  `${window.GEVME.cssClassPrefix}-live-bar`
                );
                if (livebarContainers && livebarContainers.length > 0) {
                  livebarContainers.forEach((livebarContainer) => {
                    const livebarIframeContainer =
                      livebarContainer.querySelector("iframe");
                    if (
                      livebarIframeContainer &&
                      livebarIframeContainer.contentWindow &&
                      livebarIframeContainer.contentWindow.postMessage
                    ) {
                      livebarIframeContainer.contentWindow.postMessage(
                        JSON.stringify({
                          eventType: "bookmark",
                          eventData: { type: "resource" },
                        }),
                        "*"
                      );
                    }
                  });
                }
                return result;
              }
            }
            bookmarkButtons.forEach((bookmarkButton) => {
              bookmarkButton.removeAttribute("disabled");
            });
            throw new Error(result.message);
          }
        }
      }
    }
    throw new Error("Content block or resource not found");
  } catch (error) {
    throw error;
  }
};

const searchSponsorName = (sponsorName) => {
  try {
    if (
      !sponsorName ||
      sponsorName.length === 0 ||
      typeof sponsorName !== "string"
    ) {
      sponsorName = "";
    }
    const sponsorContentBlocks = Object.values(
      window.GEVME.livepage.showcaseblocks
    ).filter((contentBlock) => contentBlock.type === "Sponsor");
    if (sponsorContentBlocks && sponsorContentBlocks.length > 0) {
      window.postMessage(
        JSON.stringify({
          action: "search",
          type: "sponsor",
          query: sponsorName,
        }),
        "*"
      );
    }
  } catch (error) {
    throw error;
  }
};

const searchSpeaker = (speakerBlockId, speakerName) => {
  try {
    const speakerBlockEl = document.querySelector(
      `div[data-content-block-id="${speakerBlockId}"]`
    );
    if (!speakerBlockEl)
      throw new Error(`Speaker block (${speakerBlockId}) not found`);
    const hasName = typeof speakerName === "string" && !!speakerName;
    const speakerNameRegex = hasName ? new RegExp(speakerName, "gi") : null;
    const speakersBlockRowEl = speakerBlockEl.querySelector(
      `div.${window.GEVME.cssClassPrefix}-speakers-block-row`
    );
    const speakersEls = speakerBlockEl.querySelectorAll(
      `div.${window.GEVME.cssClassPrefix}-speakers-block-column`
    );
    const noResultsEl = speakerBlockEl.querySelector(
      `div.${window.GEVME.cssClassPrefix}-speakers-no-results-container`
    );
    const clearIconEl = speakerBlockEl.querySelector(
      `div.${window.GEVME.cssClassPrefix}-speakers-block-clear-icon`
    );

    if (clearIconEl) {
      clearIconEl.style.display = hasName ? "block" : "none";
    }

    let totalVisibleSpeakers = 0;
    for (const speakerEl of speakersEls) {
      if (hasName) {
        const name = speakerEl.getAttribute("data-content-target") || "";
        const companyName =
          speakerEl.getAttribute("data-content-target-company") || "";
        const jobTitle =
          speakerEl.getAttribute("data-content-target-job-title") || "";
        const bio = speakerEl.getAttribute("data-content-target-bio") || "";
        const isMatch =
          name.match(speakerNameRegex) ||
          companyName.match(speakerNameRegex) ||
          jobTitle.match(speakerNameRegex) ||
          bio.match(speakerNameRegex);
        speakerEl.style.display = isMatch ? "block" : "none";
        if (isMatch) {
          totalVisibleSpeakers++;
        }
      } else {
        speakerEl.style.display = "block";
      }
    }

    if (speakersBlockRowEl) {
      if (!hasName || totalVisibleSpeakers > 0) {
        speakersBlockRowEl.style.removeProperty("display");
      } else {
        speakersBlockRowEl.style.display = "none";
      }
    }

    if (noResultsEl) {
      noResultsEl.style.display = hasName
        ? totalVisibleSpeakers === 0
          ? "block"
          : "none"
        : "none";
    }
  } catch (error) {
    console.error("searchSpeaker Error", error);
  }
};

const searchAgendaLocation = (location) => {
  try {
    if (!location || location.length === 0 || typeof location !== "string") {
      location = "";
    }
    const agendaContentBlocks = Object.values(
      window.GEVME.livepage.showcaseblocks
    ).filter((contentBlock) => contentBlock.type === "Agenda");
    if (agendaContentBlocks && agendaContentBlocks.length > 0) {
      window.postMessage(
        JSON.stringify({
          action: "agenda-location",
          type: "agenda",
          query: location,
        }),
        "*"
      );
    }
  } catch (error) {
    throw error;
  }
};

const WindowPostMessageProxy = (function () {
  function WindowPostMessageProxy(options) {
    var _this = this;
    if (options === void 0) {
      options = {
        processTrackingProperties: {
          addTrackingProperties:
            WindowPostMessageProxy.defaultAddTrackingProperties,
          getTrackingProperties:
            WindowPostMessageProxy.defaultGetTrackingProperties,
        },
        isErrorMessage: WindowPostMessageProxy.defaultIsErrorMessage,
        receiveWindow: window,
        name: WindowPostMessageProxy.createRandomString(),
      };
    }
    this.pendingRequestPromises = {};
    this.addTrackingProperties =
      (options.processTrackingProperties &&
        options.processTrackingProperties.addTrackingProperties) ||
      WindowPostMessageProxy.defaultAddTrackingProperties;
    this.getTrackingProperties =
      (options.processTrackingProperties &&
        options.processTrackingProperties.getTrackingProperties) ||
      WindowPostMessageProxy.defaultGetTrackingProperties;
    this.isErrorMessage =
      options.isErrorMessage || WindowPostMessageProxy.defaultIsErrorMessage;
    this.receiveWindow = options.receiveWindow || window;
    this.name = options.name || WindowPostMessageProxy.createRandomString();
    this.logMessages = options.logMessages || false;
    this.eventSourceOverrideWindow = options.eventSourceOverrideWindow;
    this.suppressWarnings = options.suppressWarnings || false;
    if (this.logMessages) {
      console.log(
        "new WindowPostMessageProxy created with name: " +
          this.name +
          " receiving on window: " +
          this.receiveWindow.document.title
      );
    }
    this.handlers = [];
    this.windowMessageHandler = function (event) {
      console.log({
        event,
        d: isValidDomain(event.origin, window?.GEVME?.setting?.customDomain),
      });
      if (isValidDomain(event.origin, window?.GEVME?.setting?.customDomain)) {
        return _this.onMessageReceived(event);
      }
    };
    this.start();
  }
  WindowPostMessageProxy.defaultAddTrackingProperties = function (
    message,
    trackingProperties
  ) {
    message[WindowPostMessageProxy.messagePropertyName] = trackingProperties;
    return message;
  };
  WindowPostMessageProxy.defaultGetTrackingProperties = function (message) {
    return message[WindowPostMessageProxy.messagePropertyName];
  };
  WindowPostMessageProxy.defaultIsErrorMessage = function (message) {
    return !!message.error;
  };
  WindowPostMessageProxy.createDeferred = function () {
    var deferred = {
      resolve: null,
      reject: null,
      promise: null,
    };
    var promise = new Promise(function (resolve, reject) {
      deferred.resolve = resolve;
      deferred.reject = reject;
    });
    deferred.promise = promise;
    return deferred;
  };
  WindowPostMessageProxy.createRandomString = function () {
    var cryptoObj = window.crypto || window.msCrypto;
    var randomValueArray = new Uint32Array(1);
    cryptoObj.getRandomValues(randomValueArray);
    return randomValueArray[0].toString(36).substring(1);
  };
  WindowPostMessageProxy.prototype.addHandler = function (handler) {
    this.handlers.push(handler);
  };
  WindowPostMessageProxy.prototype.removeHandler = function (handler) {
    var handlerIndex = this.handlers.indexOf(handler);
    if (handlerIndex === -1) {
      throw new Error(
        "You attempted to remove a handler but no matching handler was found."
      );
    }
    this.handlers.splice(handlerIndex, 1);
  };
  WindowPostMessageProxy.prototype.start = function () {
    this.receiveWindow.addEventListener("message", this.windowMessageHandler);
  };
  WindowPostMessageProxy.prototype.stop = function () {
    this.receiveWindow.removeEventListener(
      "message",
      this.windowMessageHandler
    );
  };
  WindowPostMessageProxy.prototype.postMessage = function (
    targetWindow,
    message
  ) {
    var trackingProperties = {
      id: WindowPostMessageProxy.createRandomString(),
    };
    this.addTrackingProperties(message, trackingProperties);
    if (this.logMessages) {
      console.log(this.name + " Posting message:");
      console.log(JSON.stringify(message, null, "  "));
    }
    targetWindow.postMessage(message, "*");
    var deferred = WindowPostMessageProxy.createDeferred();
    this.pendingRequestPromises[trackingProperties.id] = deferred;
    return deferred.promise;
  };
  WindowPostMessageProxy.prototype.sendResponse = function (
    targetWindow,
    message,
    trackingProperties
  ) {
    this.addTrackingProperties(message, trackingProperties);
    if (this.logMessages) {
      console.log(this.name + " Sending response:");
      console.log(JSON.stringify(message, null, "  "));
    }
    targetWindow.postMessage(message, "*");
  };
  WindowPostMessageProxy.prototype.onMessageReceived = function (event) {
    var _this = this;
    console.log({ _this });
    if (this.logMessages) {
      console.log(this.name + " Received message:");
      console.log("type: " + event.type);
      console.log(JSON.stringify(event.data, null, "  "));
    }
    var sendingWindow = this.eventSourceOverrideWindow || event.source;
    var message = event.data;
    if (typeof message !== "object") {
      if (!this.suppressWarnings) {
        console.warn(
          "Proxy(" +
            this.name +
            "): Received message that was not an object. Discarding message"
        );
      }
      return;
    }
    var trackingProperties;
    try {
      trackingProperties = this.getTrackingProperties(message);
    } catch (e) {
      if (!this.suppressWarnings) {
        console.warn(
          "Proxy(" +
            this.name +
            "): Error occurred when attempting to get tracking properties from incoming message:",
          JSON.stringify(message, null, "  "),
          "Error: ",
          e
        );
      }
    }
    var deferred;
    if (trackingProperties) {
      deferred = this.pendingRequestPromises[trackingProperties.id];
    }
    if (!deferred) {
      var handled = this.handlers.some(function (handler) {
        var canMessageBeHandled = false;
        try {
          canMessageBeHandled = handler.test(message);
        } catch (e) {
          if (!_this.suppressWarnings) {
            console.warn(
              "Proxy(" +
                _this.name +
                "): Error occurred when handler was testing incoming message:",
              JSON.stringify(message, null, "  "),
              "Error: ",
              e
            );
          }
        }
        if (canMessageBeHandled) {
          var responseMessagePromise = void 0;
          try {
            responseMessagePromise = Promise.resolve(handler.handle(message));
          } catch (e) {
            if (!_this.suppressWarnings) {
              console.warn(
                "Proxy(" +
                  _this.name +
                  "): Error occurred when handler was processing incoming message:",
                JSON.stringify(message, null, "  "),
                "Error: ",
                e
              );
            }
            responseMessagePromise = Promise.resolve();
          }
          responseMessagePromise.then(function (responseMessage) {
            if (!responseMessage) {
              var warningMessage =
                "Handler for message: " +
                JSON.stringify(message, null, "  ") +
                " did not return a response message. The default response message will be returned instead.";
              if (!_this.suppressWarnings) {
                console.warn("Proxy(" + _this.name + "): " + warningMessage);
              }
              responseMessage = {
                warning: warningMessage,
              };
            }
            _this.sendResponse(
              sendingWindow,
              responseMessage,
              trackingProperties
            );
          });
          return true;
        }
      });
      if (!handled && !this.suppressWarnings) {
        console.warn(
          "Proxy(" +
            this.name +
            ") did not handle message. Handlers: " +
            this.handlers.length +
            "  Message: " +
            JSON.stringify(message, null, "") +
            "."
        );
        // this.sendResponse({ notHandled: true }, trackingProperties);
      }
    } else {
      var isErrorMessage = true;
      try {
        isErrorMessage = this.isErrorMessage(message);
      } catch (e) {
        console.warn(
          "Proxy(" +
            this.name +
            ") Error occurred when trying to determine if message is consider an error response. Message: ",
          JSON.stringify(message, null, ""),
          "Error: ",
          e
        );
      }
      if (isErrorMessage) {
        deferred.reject(message);
      } else {
        deferred.resolve(message);
      }
      delete this.pendingRequestPromises[trackingProperties.id];
    }
  };
  WindowPostMessageProxy.messagePropertyName = "windowPostMessageProxy";
  return WindowPostMessageProxy;
})();

const attachScript = (urlArr) => {
  urlArr.map((url) => {
    let head = document.getElementsByTagName("head")[0];
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = url;
    head.appendChild(script);
  });
};
const attachLink = (urlArr) => {
  urlArr.map((url) => {
    let head = document.getElementsByTagName("head")[0];
    let link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = url;
    head.appendChild(link);
  });
};

const addResourceFiles = (type) => {
  try {
    switch (type) {
      case "pdf":
      case "resources":
        attachLink([
          `${process.env.REACT_APP_VENUE_SDK_BASE_URL}/styles/pdf_viewer-2.9.359.min.css`,
        ]);
        attachScript([
          `${process.env.REACT_APP_VENUE_SDK_BASE_URL}/scripts/pdfjs-2.9.359.min.js`,
          `${process.env.REACT_APP_VENUE_SDK_BASE_URL}/scripts/pdf_viewer-2.9.359.min.js`,
        ]);

        break;
      case "livestream":
        attachLink([
          `${process.env.REACT_APP_VENUE_SDK_BASE_URL}/styles/video-js-7.14.3.css`,
        ]);
        attachScript([
          `${process.env.REACT_APP_VENUE_SDK_BASE_URL}/scripts/video.min-7.14.3.js`,
          `${process.env.REACT_APP_VENUE_SDK_BASE_URL}/scripts/amazon-ivs-videojs-tech-1.6.1.min.js`,
          `${process.env.REACT_APP_VENUE_SDK_BASE_URL}/scripts/amazon-ivs-quality-plugin-1.6.1.min.js`,
          `${process.env.REACT_APP_VENUE_SDK_BASE_URL}/scripts/videojs-mux-4.js`,
        ]);
        break;
      default:
        break;
    }
  } catch (error) {
    console.error(error);
  }
};

const addBlockType = (type) => {
  try {
    const crntBlockTypes = new Set(window.GEVME.livepage.blockTypes);
    if (crntBlockTypes.has(type)) return;
    else {
      addResourceFiles(type);
      crntBlockTypes.add(type);
      window.GEVME.livepage.blockTypes = Array.from(crntBlockTypes);
    }
  } catch (error) {
    console.error(error);
  }
};
/**
 *
 * @param {object} payload  {link,openInNewWindow,previewSlug}
 */
const switchPage = (payload) => {
  window.parent.postMessage(
    JSON.stringify({ ...payload, action: "update-nav" }),
    "*"
  );
};

// The csrf token is stored by the template app (parent window), a different domain from this
// render iframe, so it is requested from there on demand
let csrfPostMessageClient = null;
const CSRF_REQUEST_TIMEOUT = 10000;

const requestCsrfFromTemplateApp = async (payload) => {
  if (!csrfPostMessageClient) {
    csrfPostMessageClient = new WindowPostMessageProxy({
      logMessages: false,
      suppressWarnings: true,
      name: window.GEVME.cssClassPrefix,
    });
  }
  let timer;
  const timeout = new Promise((resolve) => {
    timer = setTimeout(() => resolve({}), CSRF_REQUEST_TIMEOUT);
  });
  try {
    return await Promise.race([
      csrfPostMessageClient.postMessage(window.parent, {
        projectId: window.GEVME?.project?.id,
        ...payload,
      }),
      timeout,
    ]);
  } finally {
    clearTimeout(timer);
  }
};

const getCsrfToken = async () => {
  try {
    const result = await requestCsrfFromTemplateApp({ xhr: "getCsrfToken" });
    return typeof result?.csrfToken === "string" ? result.csrfToken : "";
  } catch (error) {
    console.error(error);
    return "";
  }
};

const setCsrfToken = async (csrfToken) => {
  try {
    if (typeof csrfToken !== "string" || !csrfToken) return false;
    const result = await requestCsrfFromTemplateApp({
      xhr: "setCsrfToken",
      csrfToken,
    });
    return !!result?.status;
  } catch (error) {
    console.error(error);
    return false;
  }
};

window.GEVME.utils = {
  retrieveAndRenderAllVideoBlockPlayers,
  enableMatomoMediaTracking,
  enableLiveReloadingWebSocket,
  enableImageSlideshowAutoScroll,
  checkPreviewPageLink,
  openModalPopup,
  closeModalPopup,
  checkModalPopupVisibility,
  logoutUser,
  closeOwnWindow,
  switchVenueBuilderPreview,
  enterPictureInPicture,
  exitPictureInPicture,
  renderPublicPageGenericLoginScreen,
  submitPublicPageGenericLoginScreen,
  handlePreviewNavMenuItemClick,
  openSpeakerModal,
  switchPage,
  debounceUtility,
  displayReaction,
  fetchExhibitor,
  searchSpeaker,
  getCsrfToken,
  setCsrfToken,
  WindowPostMessageProxy,
};
if (window.GEVME.isPreview)
  window.GEVME.utils = {
    ...window.GEVME.utils,
    establishPreviewConnection,
    sendPreviewAction,
  };
window.GEVME.xhr = {
  toggleResourceBookmark,
  searchSponsorName,
  searchAgendaLocation,
};

const fixedVideoJSSeekWhileMouseDragging = () => {
  try {
    const SeekBar = window.videojs.getComponent("SeekBar");

    SeekBar.prototype.getPercent = function getPercent() {
      // Allows for smooth scrubbing, when player can't keep up.
      // const time = (this.player_.scrubbing()) ?
      //   this.player_.getCache().currentTime :
      //   this.player_.currentTime()

      const time = this.player_.currentTime();
      const percent = time / this.player_.duration();
      return percent >= 1 ? 1 : percent;
    };

    SeekBar.prototype.handleMouseMove = function handleMouseMove(event) {
      this.player_.pause();
      let newTime = this.calculateDistance(event) * this.player_.duration();
      if (newTime === this.player_.duration()) {
        newTime = newTime - 0.1;
      }
      this.player_.currentTime(newTime);
      this.player_.play();
      this.update();
    };
  } catch (error) {
    console.log("videojs seek bar mouse drag error", error);
  }
};

(function () {
  try {
    const EXCLUDE_KEYS = [
      "showcaseblocks",
      "showcaseblocksweight",
      "blockTypes",
      "widgets",
      "header",
      "livebar",
      "setting",
    ];
    function deepFreeze(object) {
      // Retrieve the property names defined on object
      const propNames = Object.getOwnPropertyNames(object);
      for (const name of propNames) {
        if (!EXCLUDE_KEYS.includes(name)) {
          const value = object[name];
          if (value && typeof value === "object" && !Array.isArray(value)) {
            Object.freeze(object[name]);
            deepFreeze(value);
          }
        }
      }
    }
    deepFreeze(window.GEVME);
  } catch (error) {
    console.error(error);
  }
})();

(function () {
  try {
    const onClick = (e) => {
      window.parent.postMessage(
        JSON.stringify({
          action: "gevme-page-clicked",
          data: e,
        }),
        "*"
      );

      const frames = window.frames;
      for (let i = 0; i < frames.length; i++) {
        frames[i].postMessage(
          JSON.stringify({
            action: "gevme-page-clicked",
            data: e,
          }),
          "*"
        );
      }
    };
    document.body.addEventListener("click", onClick);

    window.onload = function () {
      if (window._paq) {
        window._paq.push(["disableCrossDomainLinking"]);
      }
      fixedVideoJSSeekWhileMouseDragging();
    };

    window.onmessage = function (event) {
      try {
        if (isValidDomain(event.origin, window?.GEVME?.setting?.customDomain)) {
          const payload = JSON.parse(event.data);

          if (payload && payload?.action === "adobe-activity") {
            return trackAdobeAnalytics(payload?.activity);
          }

          if (payload && payload?.action === "switch-page") {
            return switchPage(payload);
          }

          if (
            payload &&
            payload.type &&
            payload.data &&
            payload.data.targetWindow &&
            payload.data.targetWindow === "GevmeLiveBar"
          ) {
            document
              .querySelector(`iframe#GevmeLiveBar`)
              .contentWindow?.postMessage(
                JSON.stringify({ type: payload.type, data: payload.data }),
                "*"
              );
          }
        } else throw new Error({ status: false, message: "Invalid domain" });
      } catch (error) {
        console.error(error);
      }
    };
  } catch (error) {
    console.error(error);
  }
})();